const stationList = [
  {
    "name": "낙성대",
    "lat": 37.4770896313732,
    "lng": 126.963505817942
  },
  {
    "name": "구룡",
    "lat": 37.48702743532,
    "lng": 127.059474850454
  },
  {
    "name": "서울대입구",
    "lat": 37.4812845008265,
    "lng": 126.952695107942
  },
  {
    "name": "불광",
    "lat": 37.6100441859992,
    "lng": 126.930302239049
  },
  {
    "name": "월롱",
    "lat": 37.7962037866501,
    "lng": 126.792563197953
  },
  {
    "name": "안국",
    "lat": 37.5764929103816,
    "lng": 126.985419169939
  },
  {
    "name": "부발",
    "lat": 37.2603924025665,
    "lng": 127.490307974918
  },
  {
    "name": "강변",
    "lat": 37.535118053119,
    "lng": 127.094722999066
  },
  {
    "name": "영등포구청",
    "lat": 37.5258305232222,
    "lng": 126.896668349116
  },
  {
    "name": "동대입구",
    "lat": 37.5590504141329,
    "lng": 127.005296768227
  },
  {
    "name": "잠실새내",
    "lat": 37.5116083485804,
    "lng": 127.08630073432
  },
  {
    "name": "당산",
    "lat": 37.5347735014069,
    "lng": 126.902607283905
  },
  {
    "name": "약수",
    "lat": 37.5544909839515,
    "lng": 127.010887137982
  },
  {
    "name": "충정로",
    "lat": 37.5597479688989,
    "lng": 126.964484159441
  },
  {
    "name": "녹번",
    "lat": 37.6008031568325,
    "lng": 126.935814422277
  },
  {
    "name": "종합운동장",
    "lat": 37.5111302556967,
    "lng": 127.07383586044
  },
  {
    "name": "합정",
    "lat": 37.549901442065,
    "lng": 126.914447288631
  },
  {
    "name": "금호",
    "lat": 37.548255518095,
    "lng": 127.015820115311
  },
  {
    "name": "홍대입구",
    "lat": 37.5568635281461,
    "lng": 126.923764988566
  },
  {
    "name": "홍제",
    "lat": 37.5887881726718,
    "lng": 126.944158013369
  },
  {
    "name": "옥수",
    "lat": 37.5415518643708,
    "lng": 127.017380201215
  },
  {
    "name": "압구정",
    "lat": 37.5264849726148,
    "lng": 127.028486030642
  },
  {
    "name": "삼성",
    "lat": 37.5088119293814,
    "lng": 127.063020940329
  },
  {
    "name": "신답",
    "lat": 37.5698350860798,
    "lng": 127.04706653169
  },
  {
    "name": "신사",
    "lat": 37.5164314730183,
    "lng": 127.02029272549
  },
  {
    "name": "가정중앙시장",
    "lat": 37.5175227396599,
    "lng": 126.676805241489
  },
  {
    "name": "선릉",
    "lat": 37.5044937750958,
    "lng": 127.048948120105
  },
  {
    "name": "신정네거리",
    "lat": 37.5202158982635,
    "lng": 126.852876007423
  },
  {
    "name": "지축",
    "lat": 37.648145025133,
    "lng": 126.913836143165
  },
  {
    "name": "구파발",
    "lat": 37.6364177567586,
    "lng": 126.918834712255
  },
  {
    "name": "연신내",
    "lat": 37.6191924317614,
    "lng": 126.921096185129
  },
  {
    "name": "무악재",
    "lat": 37.5825560184073,
    "lng": 126.950230958933
  },
  {
    "name": "독립문",
    "lat": 37.5744680801684,
    "lng": 126.957911446269
  },
  {
    "name": "경복궁",
    "lat": 37.5757880985498,
    "lng": 126.973668718282
  },
  {
    "name": "종로3가",
    "lat": 37.5704208439207,
    "lng": 126.992144196794
  },
  {
    "name": "을지로3가",
    "lat": 37.5662761796769,
    "lng": 126.990967458779
  },
  {
    "name": "동오",
    "lat": 37.7452518938783,
    "lng": 127.05698049092
  },
  {
    "name": "역삼",
    "lat": 37.5006600052986,
    "lng": 127.036460414211
  },
  {
    "name": "강남",
    "lat": 37.4980854411503,
    "lng": 127.027977657727
  },
  {
    "name": "교대",
    "lat": 37.4927359601279,
    "lng": 127.013863444681
  },
  {
    "name": "방배",
    "lat": 37.4814561264392,
    "lng": 126.997535255649
  },
  {
    "name": "사당",
    "lat": 37.4765532208396,
    "lng": 126.981549541445
  },
  {
    "name": "봉천",
    "lat": 37.4824689098378,
    "lng": 126.941682007426
  },
  {
    "name": "신림",
    "lat": 37.4842644294274,
    "lng": 126.929740854865
  },
  {
    "name": "신대방",
    "lat": 37.487641446009,
    "lng": 126.913500702287
  },
  {
    "name": "구로디지털단지",
    "lat": 37.4852533671941,
    "lng": 126.901473089504
  },
  {
    "name": "신도림",
    "lat": 37.5089048744726,
    "lng": 126.891307981962
  },
  {
    "name": "문래",
    "lat": 37.5179720940164,
    "lng": 126.894756202452
  },
  {
    "name": "신촌",
    "lat": 37.5551954567089,
    "lng": 126.936962654548
  },
  {
    "name": "이대",
    "lat": 37.5568039038233,
    "lng": 126.946422762684
  },
  {
    "name": "아현",
    "lat": 37.5574025689432,
    "lng": 126.956132861047
  },
  {
    "name": "잠원",
    "lat": 37.5128827106508,
    "lng": 127.011401392881
  },
  {
    "name": "고속터미널",
    "lat": 37.5045398449292,
    "lng": 127.005134579686
  },
  {
    "name": "교대",
    "lat": 37.4927359601279,
    "lng": 127.013863444681
  },
  {
    "name": "남부터미널",
    "lat": 37.4851852186355,
    "lng": 127.016191235414
  },
  {
    "name": "양재",
    "lat": 37.4845687081114,
    "lng": 127.034146039501
  },
  {
    "name": "매봉",
    "lat": 37.4869250553702,
    "lng": 127.046697871026
  },
  {
    "name": "효자",
    "lat": 37.753979766402,
    "lng": 127.077208439712
  },
  {
    "name": "까치산",
    "lat": 37.5322270449167,
    "lng": 126.846426169396
  },
  {
    "name": "시청",
    "lat": 37.5653372841193,
    "lng": 126.977181235023
  },
  {
    "name": "을지로입구",
    "lat": 37.5660229020616,
    "lng": 126.982183995362
  },
  {
    "name": "을지로3가",
    "lat": 37.5662761796769,
    "lng": 126.990967458779
  },
  {
    "name": "을지로4가",
    "lat": 37.5666368996611,
    "lng": 126.997623004003
  },
  {
    "name": "동대문역사문화공원",
    "lat": 37.5656454859141,
    "lng": 127.008987189553
  },
  {
    "name": "신당",
    "lat": 37.5656622427144,
    "lng": 127.019468475358
  },
  {
    "name": "한양대",
    "lat": 37.5557087864257,
    "lng": 127.04361716382
  },
  {
    "name": "뚝섬",
    "lat": 37.5472379579492,
    "lng": 127.047369170783
  },
  {
    "name": "성수",
    "lat": 37.5445852156774,
    "lng": 127.056057944077
  },
  {
    "name": "건대입구",
    "lat": 37.5403976062717,
    "lng": 127.069202907348
  },
  {
    "name": "구의",
    "lat": 37.537160863174,
    "lng": 127.086171769557
  },
  {
    "name": "잠실나루",
    "lat": 37.5206944003696,
    "lng": 127.103799674868
  },
  {
    "name": "잠실",
    "lat": 37.5133092702048,
    "lng": 127.100215181119
  },
  {
    "name": "용답",
    "lat": 37.5621209757458,
    "lng": 127.050887278781
  },
  {
    "name": "도곡",
    "lat": 37.4909757841746,
    "lng": 127.055497705714
  },
  {
    "name": "대치",
    "lat": 37.4944858480401,
    "lng": 127.063189830669
  },
  {
    "name": "학여울",
    "lat": 37.4968779978912,
    "lng": 127.071153022687
  },
  {
    "name": "대청",
    "lat": 37.4937011202813,
    "lng": 127.079517936005
  },
  {
    "name": "일원",
    "lat": 37.4839850708765,
    "lng": 127.084120707858
  },
  {
    "name": "수서",
    "lat": 37.4852843181606,
    "lng": 127.10445168236
  },
  {
    "name": "가락시장",
    "lat": 37.493092048704,
    "lng": 127.118258210622
  },
  {
    "name": "경찰병원",
    "lat": 37.4959868949932,
    "lng": 127.124482367866
  },
  {
    "name": "오금",
    "lat": 37.5021280700015,
    "lng": 127.127930582636
  },
  {
    "name": "당고개",
    "lat": 37.6702060357364,
    "lng": 127.079048472278
  },
  {
    "name": "상계",
    "lat": 37.6607133396972,
    "lng": 127.073417091825
  },
  {
    "name": "노원",
    "lat": 37.6563403562037,
    "lng": 127.063440071354
  },
  {
    "name": "창동",
    "lat": 37.653320494324,
    "lng": 127.047640454654
  },
  {
    "name": "쌍문",
    "lat": 37.6485317952362,
    "lng": 127.034651559958
  },
  {
    "name": "수유",
    "lat": 37.6378664771973,
    "lng": 127.025492107399
  },
  {
    "name": "미아",
    "lat": 37.6266400754021,
    "lng": 127.026032022663
  },
  {
    "name": "미아사거리",
    "lat": 37.6132684542852,
    "lng": 127.030082101855
  },
  {
    "name": "길음",
    "lat": 37.6033767646759,
    "lng": 127.025049999193
  },
  {
    "name": "성신여대입구",
    "lat": 37.5929627242628,
    "lng": 127.017120398018
  },
  {
    "name": "한성대입구",
    "lat": 37.5884047925683,
    "lng": 127.006000831773
  },
  {
    "name": "혜화",
    "lat": 37.5820258983338,
    "lng": 127.00192463086
  },
  {
    "name": "동대문",
    "lat": 37.5716640012581,
    "lng": 127.010617962363
  },
  {
    "name": "동대문역사문화공원",
    "lat": 37.5656454859141,
    "lng": 127.008987189553
  },
  {
    "name": "충무로",
    "lat": 37.5613929793562,
    "lng": 126.994137154178
  },
  {
    "name": "명동",
    "lat": 37.5609598626754,
    "lng": 126.986395560098
  },
  {
    "name": "회현",
    "lat": 37.5587602432284,
    "lng": 126.978428202919
  },
  {
    "name": "서울",
    "lat": 37.5533163107152,
    "lng": 126.969738305903
  },
  {
    "name": "숙대입구",
    "lat": 37.5445952301115,
    "lng": 126.972118127372
  },
  {
    "name": "삼각지",
    "lat": 37.534432134689,
    "lng": 126.972913902586
  },
  {
    "name": "신용산",
    "lat": 37.5292591477099,
    "lng": 126.967960513832
  },
  {
    "name": "이촌",
    "lat": 37.5224489050814,
    "lng": 126.973325479803
  },
  {
    "name": "동작",
    "lat": 37.5029705640491,
    "lng": 126.980299007575
  },
  {
    "name": "총신대입구",
    "lat": 37.4867887823399,
    "lng": 126.982202828739
  },
  {
    "name": "사당",
    "lat": 37.4765532208396,
    "lng": 126.981549541445
  },
  {
    "name": "남태령",
    "lat": 37.4642463513885,
    "lng": 126.9890807468
  },
  {
    "name": "남영",
    "lat": 37.5405585626607,
    "lng": 126.971327574661
  },
  {
    "name": "용산",
    "lat": 37.5300691538724,
    "lng": 126.964815014401
  },
  {
    "name": "노량진",
    "lat": 37.5135712531779,
    "lng": 126.940888666744
  },
  {
    "name": "대방",
    "lat": 37.5133469218724,
    "lng": 126.926478663143
  },
  {
    "name": "어룡",
    "lat": 37.7426761348571,
    "lng": 127.085184125536
  },
  {
    "name": "영등포",
    "lat": 37.5156764732488,
    "lng": 126.90785793823
  },
  {
    "name": "신도림",
    "lat": 37.5089048744726,
    "lng": 126.891307981962
  },
  {
    "name": "이촌",
    "lat": 37.5224489050814,
    "lng": 126.973325479803
  },
  {
    "name": "서빙고",
    "lat": 37.5195501176669,
    "lng": 126.988393978303
  },
  {
    "name": "옥수",
    "lat": 37.5415518643708,
    "lng": 127.017380201215
  },
  {
    "name": "응봉",
    "lat": 37.549945423924,
    "lng": 127.034470070506
  },
  {
    "name": "왕십리",
    "lat": 37.5612611631671,
    "lng": 127.037078472459
  },
  {
    "name": "청량리",
    "lat": 37.5807185198462,
    "lng": 127.048499848096
  },
  {
    "name": "회기",
    "lat": 37.5897782042758,
    "lng": 127.058039297256
  },
  {
    "name": "외대앞",
    "lat": 37.5962624346633,
    "lng": 127.063683442668
  },
  {
    "name": "신이문",
    "lat": 37.6017744461345,
    "lng": 127.067379878325
  },
  {
    "name": "광운대",
    "lat": 37.6238337612372,
    "lng": 127.061690626596
  },
  {
    "name": "월계",
    "lat": 37.6332595324731,
    "lng": 127.058843478444
  },
  {
    "name": "녹천",
    "lat": 37.6446334490218,
    "lng": 127.051374087263
  },
  {
    "name": "창동",
    "lat": 37.653320494324,
    "lng": 127.047640454654
  },
  {
    "name": "선릉",
    "lat": 37.5044937750958,
    "lng": 127.048948120105
  },
  {
    "name": "한티",
    "lat": 37.496274896741,
    "lng": 127.052900695072
  },
  {
    "name": "도곡",
    "lat": 37.4909757841746,
    "lng": 127.055497705714
  },
  {
    "name": "개포동",
    "lat": 37.4891322712554,
    "lng": 127.066102609769
  },
  {
    "name": "대모산입구",
    "lat": 37.4915428672119,
    "lng": 127.073070267893
  },
  {
    "name": "왕십리",
    "lat": 37.5612611631671,
    "lng": 127.037078472459
  },
  {
    "name": "수서",
    "lat": 37.4852843181606,
    "lng": 127.10445168236
  },
  {
    "name": "복정",
    "lat": 37.4707382891863,
    "lng": 127.126701394602
  },
  {
    "name": "신길",
    "lat": 37.5167834187845,
    "lng": 126.918353640838
  },
  {
    "name": "중랑",
    "lat": 37.5948317972278,
    "lng": 127.075662270251
  },
  {
    "name": "상봉",
    "lat": 37.5966989669088,
    "lng": 127.085742145107
  },
  {
    "name": "망우",
    "lat": 37.5992888287112,
    "lng": 127.092358315354
  },
  {
    "name": "양원",
    "lat": 36.9637824292408,
    "lng": 129.091278461531
  },
  {
    "name": "구리",
    "lat": 37.6032563302107,
    "lng": 127.143346426709
  },
  {
    "name": "도농",
    "lat": 37.6087654214011,
    "lng": 127.161160527083
  },
  {
    "name": "양정",
    "lat": 37.6040117413696,
    "lng": 127.194671309249
  },
  {
    "name": "덕소",
    "lat": 37.58688675731,
    "lng": 127.208824585309
  },
  {
    "name": "도심",
    "lat": 37.5796354719625,
    "lng": 127.222683847152
  },
  {
    "name": "팔당",
    "lat": 37.547355858188,
    "lng": 127.243952561032
  },
  {
    "name": "운길산",
    "lat": 37.5546425550604,
    "lng": 127.310227081777
  },
  {
    "name": "양수",
    "lat": 37.545959836992,
    "lng": 127.329133838785
  },
  {
    "name": "신원",
    "lat": 37.5255748032696,
    "lng": 127.37307354466
  },
  {
    "name": "국수",
    "lat": 37.5161727619303,
    "lng": 127.399291654314
  },
  {
    "name": "아신",
    "lat": 37.5139077890841,
    "lng": 127.443211435249
  },
  {
    "name": "오빈",
    "lat": 37.5061491723811,
    "lng": 127.473656769528
  },
  {
    "name": "석계",
    "lat": 37.6150019340823,
    "lng": 127.065670206166
  },
  {
    "name": "양평",
    "lat": 37.5255688309654,
    "lng": 126.886419299276
  },
  {
    "name": "원덕",
    "lat": 37.4687673200292,
    "lng": 127.546558574942
  },
  {
    "name": "용문",
    "lat": 37.4826100652581,
    "lng": 127.594371532679
  },
  {
    "name": "지평",
    "lat": 37.4768771035447,
    "lng": 127.629666516091
  },
  {
    "name": "서울",
    "lat": 37.5533163107152,
    "lng": 126.969738305903
  },
  {
    "name": "신촌",
    "lat": 37.5551954567089,
    "lng": 126.936962654548
  },
  {
    "name": "효창공원앞",
    "lat": 37.5392943328525,
    "lng": 126.961393582224
  },
  {
    "name": "공덕",
    "lat": 37.5445344743163,
    "lng": 126.95143307723
  },
  {
    "name": "서강대",
    "lat": 37.5521312710891,
    "lng": 126.93549404719
  },
  {
    "name": "홍대입구",
    "lat": 37.5568635281461,
    "lng": 126.923764988566
  },
  {
    "name": "수색",
    "lat": 37.5808084927877,
    "lng": 126.895641436132
  },
  {
    "name": "화전",
    "lat": 37.6033060363963,
    "lng": 126.868385736287
  },
  {
    "name": "강매",
    "lat": 37.6122868634543,
    "lng": 126.844494840384
  },
  {
    "name": "행신",
    "lat": 37.6119666245481,
    "lng": 126.834279560012
  },
  {
    "name": "능곡",
    "lat": 37.6190100922675,
    "lng": 126.82042239442
  },
  {
    "name": "곡산",
    "lat": 37.6457575386699,
    "lng": 126.801797828017
  },
  {
    "name": "백마",
    "lat": 37.6580165981743,
    "lng": 126.794602870293
  },
  {
    "name": "풍산",
    "lat": 37.6723273576378,
    "lng": 126.786266180087
  },
  {
    "name": "일산",
    "lat": 37.6820093022534,
    "lng": 126.77000451545
  },
  {
    "name": "탄현",
    "lat": 37.6939744831672,
    "lng": 126.761055632314
  },
  {
    "name": "야당",
    "lat": 37.7126074026376,
    "lng": 126.761449458429
  },
  {
    "name": "운정",
    "lat": 37.725592771562,
    "lng": 126.767147450181
  },
  {
    "name": "금릉",
    "lat": 37.7513209199973,
    "lng": 126.765387482299
  },
  {
    "name": "금촌",
    "lat": 37.7661507617625,
    "lng": 126.774601706879
  },
  {
    "name": "파주",
    "lat": 37.8153583754851,
    "lng": 126.792691322964
  },
  {
    "name": "문산",
    "lat": 37.8546124470985,
    "lng": 126.78737723979
  },
  {
    "name": "임진강",
    "lat": 37.8882642054943,
    "lng": 126.747060302928
  },
  {
    "name": "광운대",
    "lat": 37.6238337612372,
    "lng": 127.061690626596
  },
  {
    "name": "청량리",
    "lat": 37.5807185198462,
    "lng": 127.048499848096
  },
  {
    "name": "회기",
    "lat": 37.5897782042758,
    "lng": 127.058039297256
  },
  {
    "name": "상봉",
    "lat": 37.5966989669088,
    "lng": 127.085742145107
  },
  {
    "name": "망우",
    "lat": 37.5992888287112,
    "lng": 127.092358315354
  },
  {
    "name": "신내",
    "lat": 37.612487415788,
    "lng": 127.104266904089
  },
  {
    "name": "갈매",
    "lat": 37.6340653389188,
    "lng": 127.114742608717
  },
  {
    "name": "별내",
    "lat": 37.6420535569769,
    "lng": 127.126969124631
  },
  {
    "name": "퇴계원",
    "lat": 37.6482513637596,
    "lng": 127.143523511236
  },
  {
    "name": "사릉",
    "lat": 37.6511071806435,
    "lng": 127.176912564902
  },
  {
    "name": "금곡",
    "lat": 37.6373443631905,
    "lng": 127.20751551717
  },
  {
    "name": "평내호평",
    "lat": 37.6532030105113,
    "lng": 127.244434400427
  },
  {
    "name": "천마산",
    "lat": 37.6592205029108,
    "lng": 127.285049073287
  },
  {
    "name": "마석",
    "lat": 37.6527742200656,
    "lng": 127.311677414031
  },
  {
    "name": "대성리",
    "lat": 37.6839829102845,
    "lng": 127.379692613895
  },
  {
    "name": "청평",
    "lat": 37.7355020498164,
    "lng": 127.426604627072
  },
  {
    "name": "상천",
    "lat": 37.7701748704458,
    "lng": 127.454497500058
  },
  {
    "name": "가평",
    "lat": 37.814505656393,
    "lng": 127.510734782716
  },
  {
    "name": "굴봉산",
    "lat": 37.8320589844517,
    "lng": 127.55776980717
  },
  {
    "name": "백양리",
    "lat": 37.830788191587,
    "lng": 127.589315872268
  },
  {
    "name": "강촌",
    "lat": 37.8057074126255,
    "lng": 127.634128739716
  },
  {
    "name": "디지털미디어시티",
    "lat": 37.5760020219691,
    "lng": 126.901263083061
  },
  {
    "name": "김유정",
    "lat": 37.8184383066528,
    "lng": 127.71430569321
  },
  {
    "name": "남춘천",
    "lat": 37.8640396913213,
    "lng": 127.723814225754
  },
  {
    "name": "춘천",
    "lat": 37.8844983510399,
    "lng": 127.716693906996
  },
  {
    "name": "봉명",
    "lat": 36.8014198381628,
    "lng": 127.136033629949
  },
  {
    "name": "쌍용",
    "lat": 36.7937221873478,
    "lng": 127.12136482043
  },
  {
    "name": "아산",
    "lat": 36.7946033931316,
    "lng": 127.104357916141
  },
  {
    "name": "배방",
    "lat": 36.7776965034054,
    "lng": 127.052783609867
  },
  {
    "name": "온양온천",
    "lat": 36.7805376748432,
    "lng": 127.003181472643
  },
  {
    "name": "신창",
    "lat": 36.769624275712,
    "lng": 126.95138861374
  },
  {
    "name": "선바위",
    "lat": 37.4517407809454,
    "lng": 127.002215131762
  },
  {
    "name": "경마공원",
    "lat": 37.4439557812032,
    "lng": 127.007819960946
  },
  {
    "name": "대공원",
    "lat": 37.4360449337415,
    "lng": 127.006734401918
  },
  {
    "name": "과천",
    "lat": 37.4328735001529,
    "lng": 126.996610343398
  },
  {
    "name": "정부과천청사",
    "lat": 37.4264939139217,
    "lng": 126.989854488907
  },
  {
    "name": "인덕원",
    "lat": 37.4014797519481,
    "lng": 126.976666306687
  },
  {
    "name": "평촌",
    "lat": 37.3942322968183,
    "lng": 126.963794473939
  },
  {
    "name": "범계",
    "lat": 37.3897765383406,
    "lng": 126.950765206422
  },
  {
    "name": "금정",
    "lat": 37.3724555868554,
    "lng": 126.943460747528
  },
  {
    "name": "삼동",
    "lat": 37.4086775154071,
    "lng": 127.203359037744
  },
  {
    "name": "경기광주",
    "lat": 37.3989402284654,
    "lng": 127.253273621089
  },
  {
    "name": "초월",
    "lat": 37.3733683173439,
    "lng": 127.299905180106
  },
  {
    "name": "곤지암",
    "lat": 37.3505359521273,
    "lng": 127.346246812641
  },
  {
    "name": "신둔도예촌",
    "lat": 37.3156050837436,
    "lng": 127.405222655085
  },
  {
    "name": "이천",
    "lat": 37.2642222250614,
    "lng": 127.442149821859
  },
  {
    "name": "여주",
    "lat": 37.2828596957647,
    "lng": 127.62852003343
  },
  {
    "name": "구로",
    "lat": 37.5033280243545,
    "lng": 126.882291119347
  },
  {
    "name": "가산디지털단지",
    "lat": 37.4803887400743,
    "lng": 126.882643680055
  },
  {
    "name": "금천구청",
    "lat": 37.4561799500543,
    "lng": 126.893599593129
  },
  {
    "name": "석수",
    "lat": 37.4350857189035,
    "lng": 126.90230723405
  },
  {
    "name": "관악",
    "lat": 37.4195571394685,
    "lng": 126.908495489831
  },
  {
    "name": "안양",
    "lat": 37.401853193434,
    "lng": 126.922634762501
  },
  {
    "name": "명학",
    "lat": 37.3844532109689,
    "lng": 126.935592797832
  },
  {
    "name": "금정",
    "lat": 37.3724555868554,
    "lng": 126.943460747528
  },
  {
    "name": "의왕",
    "lat": 37.3203421093152,
    "lng": 126.947967475613
  },
  {
    "name": "성균관대",
    "lat": 37.3003289994931,
    "lng": 126.971012976824
  },
  {
    "name": "화서",
    "lat": 37.2839872655598,
    "lng": 126.989603013382
  },
  {
    "name": "수원",
    "lat": 37.2657867038031,
    "lng": 127.000090190749
  },
  {
    "name": "독산",
    "lat": 37.4659611473931,
    "lng": 126.889471139645
  },
  {
    "name": "세류",
    "lat": 37.2438725206491,
    "lng": 127.013795188267
  },
  {
    "name": "군포",
    "lat": 37.3541850663191,
    "lng": 126.948508477572
  },
  {
    "name": "병점",
    "lat": 37.2067454948774,
    "lng": 127.033186851871
  },
  {
    "name": "세마",
    "lat": 37.187117263775,
    "lng": 127.043426806993
  },
  {
    "name": "오산대",
    "lat": 37.1693396260189,
    "lng": 127.063075717411
  },
  {
    "name": "송탄",
    "lat": 37.0757054527557,
    "lng": 127.054271459719
  },
  {
    "name": "서정리",
    "lat": 37.0565492930081,
    "lng": 127.052863705224
  },
  {
    "name": "평택",
    "lat": 36.9909679456145,
    "lng": 127.085282090336
  },
  {
    "name": "성환",
    "lat": 36.916122379095,
    "lng": 127.126877790465
  },
  {
    "name": "직산",
    "lat": 36.8709220503975,
    "lng": 127.14380576372
  },
  {
    "name": "두정",
    "lat": 36.8335918342985,
    "lng": 127.149071859029
  },
  {
    "name": "천안",
    "lat": 36.8089943586122,
    "lng": 127.146827684755
  },
  {
    "name": "당정",
    "lat": 37.3436790011333,
    "lng": 126.948357655292
  },
  {
    "name": "서동탄",
    "lat": 37.1957279421118,
    "lng": 127.051856774263
  },
  {
    "name": "광명",
    "lat": 37.4164369211351,
    "lng": 126.884799479023
  },
  {
    "name": "산본",
    "lat": 37.3580157018612,
    "lng": 126.933041817991
  },
  {
    "name": "대야미",
    "lat": 37.3279651196109,
    "lng": 126.916888493064
  },
  {
    "name": "반월",
    "lat": 37.3123673429765,
    "lng": 126.903819948122
  },
  {
    "name": "상록수",
    "lat": 37.3028523388998,
    "lng": 126.866587593057
  },
  {
    "name": "한대앞",
    "lat": 37.3097570214788,
    "lng": 126.853670620172
  },
  {
    "name": "중앙",
    "lat": 37.3160084809025,
    "lng": 126.838496396948
  },
  {
    "name": "고잔",
    "lat": 37.3167972714743,
    "lng": 126.823016567504
  },
  {
    "name": "초지",
    "lat": 37.3206629744686,
    "lng": 126.80594908949
  },
  {
    "name": "안산",
    "lat": 37.3270130414371,
    "lng": 126.788872916065
  },
  {
    "name": "신길온천",
    "lat": 37.3376222448823,
    "lng": 126.767041475711
  },
  {
    "name": "정왕",
    "lat": 37.3518085060046,
    "lng": 126.742911898934
  },
  {
    "name": "오이도",
    "lat": 37.3616918424846,
    "lng": 126.738385506047
  },
  {
    "name": "수리산",
    "lat": 37.3505507556783,
    "lng": 126.925621928603
  },
  {
    "name": "오이도",
    "lat": 37.3616918424846,
    "lng": 126.738385506047
  },
  {
    "name": "개봉",
    "lat": 37.4946344799821,
    "lng": 126.858693356963
  },
  {
    "name": "오류동",
    "lat": 37.4943827932767,
    "lng": 126.844807477983
  },
  {
    "name": "역곡",
    "lat": 37.4853071505875,
    "lng": 126.812059338728
  },
  {
    "name": "부천",
    "lat": 37.4839780556595,
    "lng": 126.783072729615
  },
  {
    "name": "송내",
    "lat": 37.4876132028813,
    "lng": 126.753030639866
  },
  {
    "name": "부평",
    "lat": 37.4894418243737,
    "lng": 126.724326592211
  },
  {
    "name": "백운",
    "lat": 37.4833280348289,
    "lng": 126.707276374028
  },
  {
    "name": "주안",
    "lat": 37.4650388163816,
    "lng": 126.679947643466
  },
  {
    "name": "제물포",
    "lat": 37.4667222404173,
    "lng": 126.656948338954
  },
  {
    "name": "동인천",
    "lat": 37.4754068295241,
    "lng": 126.632602470436
  },
  {
    "name": "인천",
    "lat": 37.4761495749499,
    "lng": 126.616816630533
  },
  {
    "name": "구일",
    "lat": 37.4962509036903,
    "lng": 126.869682064958
  },
  {
    "name": "세종대왕릉",
    "lat": 37.2936227977261,
    "lng": 127.570641519645
  },
  {
    "name": "오산",
    "lat": 37.1447027564949,
    "lng": 127.066612100655
  },
  {
    "name": "진위",
    "lat": 37.1100682181691,
    "lng": 127.06235148447
  },
  {
    "name": "동암",
    "lat": 37.4706849292696,
    "lng": 126.702871709229
  },
  {
    "name": "소사",
    "lat": 37.482793087788,
    "lng": 126.795626202003
  },
  {
    "name": "부개",
    "lat": 37.4884698252674,
    "lng": 126.740725591772
  },
  {
    "name": "간석",
    "lat": 37.464696355987,
    "lng": 126.693513421034
  },
  {
    "name": "도원",
    "lat": 37.4687697921083,
    "lng": 126.642514822715
  },
  {
    "name": "온수",
    "lat": 37.4919566907461,
    "lng": 126.823825338009
  },
  {
    "name": "중동",
    "lat": 37.4866635779738,
    "lng": 126.764521602065
  },
  {
    "name": "도화",
    "lat": 37.4661066864842,
    "lng": 126.668571461535
  },
  {
    "name": "서울숲",
    "lat": 37.5436349863299,
    "lng": 127.044741683677
  },
  {
    "name": "압구정로데오",
    "lat": 37.5275085746723,
    "lng": 127.040591450907
  },
  {
    "name": "강남구청",
    "lat": 37.5172008632289,
    "lng": 127.041287183507
  },
  {
    "name": "선정릉",
    "lat": 37.5109290398758,
    "lng": 127.043613714302
  },
  {
    "name": "가천대",
    "lat": 37.4485553966264,
    "lng": 127.126686575598
  },
  {
    "name": "태평",
    "lat": 37.4397783922336,
    "lng": 127.127733967247
  },
  {
    "name": "모란",
    "lat": 37.4340274873996,
    "lng": 127.129961399904
  },
  {
    "name": "야탑",
    "lat": 37.4113592441031,
    "lng": 127.128724893214
  },
  {
    "name": "서현",
    "lat": 37.3850010247088,
    "lng": 127.123417906034
  },
  {
    "name": "수내",
    "lat": 37.3784687717688,
    "lng": 127.114284330024
  },
  {
    "name": "정자",
    "lat": 37.3661666006259,
    "lng": 127.108079384783
  },
  {
    "name": "미금",
    "lat": 37.3500734029357,
    "lng": 127.109004370819
  },
  {
    "name": "이매",
    "lat": 37.3947099349286,
    "lng": 127.12729606911
  },
  {
    "name": "구성",
    "lat": 37.298969852535,
    "lng": 127.10568228858
  },
  {
    "name": "신갈",
    "lat": 37.2861339496318,
    "lng": 127.111280218134
  },
  {
    "name": "상갈",
    "lat": 37.2618082437676,
    "lng": 127.108719212195
  },
  {
    "name": "청명",
    "lat": 37.2595251647421,
    "lng": 127.078955458006
  },
  {
    "name": "영통",
    "lat": 37.2514926997707,
    "lng": 127.071327398854
  },
  {
    "name": "망포",
    "lat": 37.2458239558382,
    "lng": 127.056850262151
  },
  {
    "name": "매탄권선",
    "lat": 37.2524983006233,
    "lng": 127.040804144693
  },
  {
    "name": "수원시청",
    "lat": 37.2619082048643,
    "lng": 127.030843654285
  },
  {
    "name": "매교",
    "lat": 37.2655153241199,
    "lng": 127.015896062558
  },
  {
    "name": "달월",
    "lat": 37.3800159245433,
    "lng": 126.745389964029
  },
  {
    "name": "월곶",
    "lat": 37.3918134963283,
    "lng": 126.74270758579
  },
  {
    "name": "소래포구",
    "lat": 37.4009294022636,
    "lng": 126.73348308512
  },
  {
    "name": "인천논현",
    "lat": 37.4006519717694,
    "lng": 126.722551492881
  },
  {
    "name": "호구포",
    "lat": 37.4016277462904,
    "lng": 126.708678709295
  },
  {
    "name": "남동인더스파크",
    "lat": 37.4077387430964,
    "lng": 126.695213952196
  },
  {
    "name": "원인재",
    "lat": 37.4123688424567,
    "lng": 126.68787555936
  },
  {
    "name": "청량리",
    "lat": 37.5807185198462,
    "lng": 127.048499848096
  },
  {
    "name": "보정",
    "lat": 37.3127713305833,
    "lng": 127.108318762458
  },
  {
    "name": "연수",
    "lat": 37.4179126667421,
    "lng": 126.678747524614
  },
  {
    "name": "송도",
    "lat": 37.4299544246079,
    "lng": 126.654675746817
  },
  {
    "name": "인하대",
    "lat": 37.4483205697851,
    "lng": 126.649754461755
  },
  {
    "name": "숭의",
    "lat": 37.4607923513233,
    "lng": 126.638393301309
  },
  {
    "name": "인천",
    "lat": 37.4761495749499,
    "lng": 126.616816630533
  },
  {
    "name": "방학",
    "lat": 37.6674311601371,
    "lng": 127.044317183294
  },
  {
    "name": "도봉",
    "lat": 37.6791974925121,
    "lng": 127.045525808977
  },
  {
    "name": "도봉산",
    "lat": 37.6895585326698,
    "lng": 127.046053675471
  },
  {
    "name": "망월사",
    "lat": 37.7102083547787,
    "lng": 127.047404669624
  },
  {
    "name": "회룡",
    "lat": 37.7237950762834,
    "lng": 127.047277212627
  },
  {
    "name": "의정부",
    "lat": 37.7383552881432,
    "lng": 127.045947746215
  },
  {
    "name": "가능",
    "lat": 37.7483927208896,
    "lng": 127.044274646711
  },
  {
    "name": "녹양",
    "lat": 37.7593852598143,
    "lng": 127.042261194277
  },
  {
    "name": "양주",
    "lat": 37.7741241429389,
    "lng": 127.044721308837
  },
  {
    "name": "덕계",
    "lat": 37.8187525902328,
    "lng": 127.056673506557
  },
  {
    "name": "덕정",
    "lat": 37.8431840486326,
    "lng": 127.061554773951
  },
  {
    "name": "지행",
    "lat": 37.8918743050254,
    "lng": 127.055660861893
  },
  {
    "name": "동두천중앙",
    "lat": 37.9017663228673,
    "lng": 127.056418741871
  },
  {
    "name": "보산",
    "lat": 37.9141449311302,
    "lng": 127.057156006911
  },
  {
    "name": "동두천",
    "lat": 37.9276060650776,
    "lng": 127.054914346206
  },
  {
    "name": "원당",
    "lat": 37.653099388064,
    "lng": 126.842913931542
  },
  {
    "name": "대곡",
    "lat": 37.631681128995,
    "lng": 126.810920972324
  },
  {
    "name": "백석",
    "lat": 37.6429587368303,
    "lng": 126.788117923412
  },
  {
    "name": "마두",
    "lat": 37.6522375070419,
    "lng": 126.77759814216
  },
  {
    "name": "정발산",
    "lat": 37.6594734121857,
    "lng": 126.773405982778
  },
  {
    "name": "주엽",
    "lat": 37.6701350355631,
    "lng": 126.761245434965
  },
  {
    "name": "대화",
    "lat": 37.6761429324264,
    "lng": 126.747487417179
  },
  {
    "name": "방화",
    "lat": 37.5775887548875,
    "lng": 126.81280121976
  },
  {
    "name": "개화산",
    "lat": 37.5725335465697,
    "lng": 126.806814324288
  },
  {
    "name": "김포공항",
    "lat": 37.5619477391215,
    "lng": 126.801906881417
  },
  {
    "name": "송정",
    "lat": 37.5611540020654,
    "lng": 126.812412256202
  },
  {
    "name": "마곡",
    "lat": 37.5602178056843,
    "lng": 126.824683361642
  },
  {
    "name": "발산",
    "lat": 37.5586687177515,
    "lng": 126.8377251087
  },
  {
    "name": "우장산",
    "lat": 37.5488098724086,
    "lng": 126.836320627782
  },
  {
    "name": "화곡",
    "lat": 37.5416435540232,
    "lng": 126.840432411284
  },
  {
    "name": "원흥",
    "lat": 37.6506849598556,
    "lng": 126.873016181785
  },
  {
    "name": "까치산",
    "lat": 37.5322270449167,
    "lng": 126.846426169396
  },
  {
    "name": "신정",
    "lat": 37.5250131753674,
    "lng": 126.856079401594
  },
  {
    "name": "목동",
    "lat": 37.52612248118,
    "lng": 126.864607193772
  },
  {
    "name": "오목교",
    "lat": 37.5245304608023,
    "lng": 126.875289218474
  },
  {
    "name": "양평",
    "lat": 37.5255688309654,
    "lng": 126.886419299276
  },
  {
    "name": "영등포구청",
    "lat": 37.5258305232222,
    "lng": 126.896668349116
  },
  {
    "name": "영등포시장",
    "lat": 37.5227021758736,
    "lng": 126.905179576089
  },
  {
    "name": "신길",
    "lat": 37.5167834187845,
    "lng": 126.918353640838
  },
  {
    "name": "여의도",
    "lat": 37.5211664706025,
    "lng": 126.924638422261
  },
  {
    "name": "여의나루",
    "lat": 37.5271361343623,
    "lng": 126.932981451891
  },
  {
    "name": "마포",
    "lat": 37.5395405068307,
    "lng": 126.945846741087
  },
  {
    "name": "공덕",
    "lat": 37.5445344743163,
    "lng": 126.95143307723
  },
  {
    "name": "애오개",
    "lat": 37.553402332792,
    "lng": 126.956655789028
  },
  {
    "name": "충정로",
    "lat": 37.5597479688989,
    "lng": 126.964484159441
  },
  {
    "name": "서대문",
    "lat": 37.5657492320378,
    "lng": 126.966631900266
  },
  {
    "name": "광화문",
    "lat": 37.5716441018605,
    "lng": 126.976409565513
  },
  {
    "name": "종로3가",
    "lat": 37.5704208439207,
    "lng": 126.992144196794
  },
  {
    "name": "을지로4가",
    "lat": 37.5666368996611,
    "lng": 126.997623004003
  },
  {
    "name": "동대문역사문화공원",
    "lat": 37.5656454859141,
    "lng": 127.008987189553
  },
  {
    "name": "청구",
    "lat": 37.5602029883938,
    "lng": 127.013921207826
  },
  {
    "name": "신금호",
    "lat": 37.5544716890745,
    "lng": 127.020484110799
  },
  {
    "name": "행당",
    "lat": 37.5573529744311,
    "lng": 127.029493728053
  },
  {
    "name": "왕십리",
    "lat": 37.5612611631671,
    "lng": 127.037078472459
  },
  {
    "name": "마장",
    "lat": 37.5661245472562,
    "lng": 127.042966737062
  },
  {
    "name": "답십리",
    "lat": 37.5669676097486,
    "lng": 127.05254316093
  },
  {
    "name": "장한평",
    "lat": 37.5615921805583,
    "lng": 127.063699193793
  },
  {
    "name": "군자",
    "lat": 37.5571496975138,
    "lng": 127.079494769075
  },
  {
    "name": "아차산",
    "lat": 37.5522410643204,
    "lng": 127.089561549724
  },
  {
    "name": "광나루",
    "lat": 37.545291967554,
    "lng": 127.103516928227
  },
  {
    "name": "천호",
    "lat": 37.5384968055586,
    "lng": 127.123919374783
  },
  {
    "name": "강동",
    "lat": 37.5358747268317,
    "lng": 127.132378184615
  },
  {
    "name": "길동",
    "lat": 37.5378120875517,
    "lng": 127.140007691428
  },
  {
    "name": "삼송",
    "lat": 37.6530677292421,
    "lng": 126.895653717805
  },
  {
    "name": "굽은다리",
    "lat": 37.545503186603,
    "lng": 127.14287366158
  },
  {
    "name": "명일",
    "lat": 37.5513942973681,
    "lng": 127.144039211129
  },
  {
    "name": "고덕",
    "lat": 37.5550395608369,
    "lng": 127.154163861206
  },
  {
    "name": "상일동",
    "lat": 37.5566634789051,
    "lng": 127.165892145281
  },
  {
    "name": "둔촌동",
    "lat": 37.527653243694,
    "lng": 127.136210118019
  },
  {
    "name": "올림픽공원",
    "lat": 37.5163245709914,
    "lng": 127.130963650207
  },
  {
    "name": "방이",
    "lat": 37.5087434268367,
    "lng": 127.126086986658
  },
  {
    "name": "오금",
    "lat": 37.5021280700015,
    "lng": 127.127930582636
  },
  {
    "name": "개롱",
    "lat": 37.4979574766853,
    "lng": 127.13507053201
  },
  {
    "name": "마천",
    "lat": 37.495034582344,
    "lng": 127.152841764562
  },
  {
    "name": "응암",
    "lat": 37.598483842041,
    "lng": 126.915524077713
  },
  {
    "name": "역촌",
    "lat": 37.6062193423086,
    "lng": 126.922831293899
  },
  {
    "name": "불광",
    "lat": 37.6100441859992,
    "lng": 126.930302239049
  },
  {
    "name": "연신내",
    "lat": 37.6191924317614,
    "lng": 126.921096185129
  },
  {
    "name": "구산",
    "lat": 37.6112430835611,
    "lng": 126.917253818257
  },
  {
    "name": "새절",
    "lat": 37.5908600347313,
    "lng": 126.913562546888
  },
  {
    "name": "증산",
    "lat": 37.5837391279813,
    "lng": 126.909472356624
  },
  {
    "name": "디지털미디어시티",
    "lat": 37.5760020219691,
    "lng": 126.901263083061
  },
  {
    "name": "월드컵경기장",
    "lat": 37.5696211494292,
    "lng": 126.899098167507
  },
  {
    "name": "마포구청",
    "lat": 37.5634799638172,
    "lng": 126.903407498445
  },
  {
    "name": "망원",
    "lat": 37.5560790523854,
    "lng": 126.910094334311
  },
  {
    "name": "합정",
    "lat": 37.549901442065,
    "lng": 126.914447288631
  },
  {
    "name": "상수",
    "lat": 37.5477625707505,
    "lng": 126.922416317552
  },
  {
    "name": "광흥창",
    "lat": 37.5474801664168,
    "lng": 126.932012687537
  },
  {
    "name": "대흥",
    "lat": 37.5476298835021,
    "lng": 126.942468676122
  },
  {
    "name": "공덕",
    "lat": 37.5445344743163,
    "lng": 126.95143307723
  },
  {
    "name": "효창공원앞",
    "lat": 37.5392943328525,
    "lng": 126.961393582224
  },
  {
    "name": "삼각지",
    "lat": 37.534432134689,
    "lng": 126.972913902586
  },
  {
    "name": "녹사평",
    "lat": 37.5347047736434,
    "lng": 126.986536101295
  },
  {
    "name": "이태원",
    "lat": 37.534507184382,
    "lng": 126.994320286276
  },
  {
    "name": "한강진",
    "lat": 37.5397871707134,
    "lng": 127.001742505154
  },
  {
    "name": "버티고개",
    "lat": 37.5478239071303,
    "lng": 127.00672181283
  },
  {
    "name": "약수",
    "lat": 37.5544909839515,
    "lng": 127.010887137982
  },
  {
    "name": "거여",
    "lat": 37.4933160395092,
    "lng": 127.143769291109
  },
  {
    "name": "독바위",
    "lat": 37.6184069418122,
    "lng": 126.93303553594
  },
  {
    "name": "신당",
    "lat": 37.5656622427144,
    "lng": 127.019468475358
  },
  {
    "name": "동묘앞",
    "lat": 37.5732130585579,
    "lng": 127.016346114277
  },
  {
    "name": "창신",
    "lat": 37.5794120427143,
    "lng": 127.015283298946
  },
  {
    "name": "보문",
    "lat": 37.5855380945306,
    "lng": 127.019994457457
  },
  {
    "name": "안암",
    "lat": 37.5862930020861,
    "lng": 127.02923341461
  },
  {
    "name": "고려대",
    "lat": 37.5904356061366,
    "lng": 127.036300356742
  },
  {
    "name": "월곡",
    "lat": 37.6018044220648,
    "lng": 127.041447136594
  },
  {
    "name": "상월곡",
    "lat": 37.6065408142226,
    "lng": 127.048811061085
  },
  {
    "name": "돌곶이",
    "lat": 37.6105378127498,
    "lng": 127.056424528377
  },
  {
    "name": "석계",
    "lat": 37.6150019340823,
    "lng": 127.065670206166
  },
  {
    "name": "태릉입구",
    "lat": 37.6184559179347,
    "lng": 127.075391704694
  },
  {
    "name": "봉화산",
    "lat": 37.6173454295036,
    "lng": 127.091361241699
  },
  {
    "name": "장암",
    "lat": 37.6999529625254,
    "lng": 127.052818308021
  },
  {
    "name": "도봉산",
    "lat": 37.6895585326698,
    "lng": 127.046053675471
  },
  {
    "name": "수락산",
    "lat": 37.6778778660233,
    "lng": 127.055341897382
  },
  {
    "name": "마들",
    "lat": 37.6651909458561,
    "lng": 127.057689943554
  },
  {
    "name": "노원",
    "lat": 37.6563403562037,
    "lng": 127.063440071354
  },
  {
    "name": "중계",
    "lat": 37.6450777073231,
    "lng": 127.064110346569
  },
  {
    "name": "하계",
    "lat": 37.6364621312659,
    "lng": 127.067977670097
  },
  {
    "name": "태릉입구",
    "lat": 37.6184559179347,
    "lng": 127.075391704694
  },
  {
    "name": "먹골",
    "lat": 37.6106157806661,
    "lng": 127.077762184215
  },
  {
    "name": "중화",
    "lat": 37.6025418946255,
    "lng": 127.079293906515
  },
  {
    "name": "상봉",
    "lat": 37.5966989669088,
    "lng": 127.085742145107
  },
  {
    "name": "면목",
    "lat": 37.5886968712998,
    "lng": 127.08749925382
  },
  {
    "name": "사가정",
    "lat": 37.5809295768134,
    "lng": 127.088486427527
  },
  {
    "name": "용마산",
    "lat": 37.573704888224,
    "lng": 127.086757224194
  },
  {
    "name": "중곡",
    "lat": 37.5658680402426,
    "lng": 127.084257974673
  },
  {
    "name": "군자",
    "lat": 37.5571496975138,
    "lng": 127.079494769075
  },
  {
    "name": "어린이대공원",
    "lat": 37.5479446668453,
    "lng": 127.074641659468
  },
  {
    "name": "건대입구",
    "lat": 37.5403976062717,
    "lng": 127.069202907348
  },
  {
    "name": "뚝섬유원지",
    "lat": 37.5315511803549,
    "lng": 127.06677359647
  },
  {
    "name": "청구",
    "lat": 37.5602029883938,
    "lng": 127.013921207826
  },
  {
    "name": "화랑대",
    "lat": 37.6198379616943,
    "lng": 127.083525948283
  },
  {
    "name": "청담",
    "lat": 37.5194483760543,
    "lng": 127.053708883222
  },
  {
    "name": "강남구청",
    "lat": 37.5172008632289,
    "lng": 127.041287183507
  },
  {
    "name": "학동",
    "lat": 37.5143566006166,
    "lng": 127.031897380783
  },
  {
    "name": "논현",
    "lat": 37.5111873890283,
    "lng": 127.02164858363
  },
  {
    "name": "반포",
    "lat": 37.5081434093748,
    "lng": 127.011581635081
  },
  {
    "name": "고속터미널",
    "lat": 37.5045398449292,
    "lng": 127.005134579686
  },
  {
    "name": "내방",
    "lat": 37.4876549159776,
    "lng": 126.993577566695
  },
  {
    "name": "이수",
    "lat": 37.4867887823399,
    "lng": 126.982202828739
  },
  {
    "name": "남성",
    "lat": 37.4847862998916,
    "lng": 126.970896635447
  },
  {
    "name": "숭실대입구",
    "lat": 37.4963136741799,
    "lng": 126.953612918928
  },
  {
    "name": "상도",
    "lat": 37.5028526010093,
    "lng": 126.94790894056
  },
  {
    "name": "장승배기",
    "lat": 37.5048846414365,
    "lng": 126.939063345317
  },
  {
    "name": "신대방삼거리",
    "lat": 37.4997428128212,
    "lng": 126.928210959471
  },
  {
    "name": "보라매",
    "lat": 37.4999181359871,
    "lng": 126.920588561199
  },
  {
    "name": "신풍",
    "lat": 37.5001085601918,
    "lng": 126.909731743281
  },
  {
    "name": "대림",
    "lat": 37.4933027323738,
    "lng": 126.894926522974
  },
  {
    "name": "남구로",
    "lat": 37.4869892904115,
    "lng": 126.887970257024
  },
  {
    "name": "가산디지털단지",
    "lat": 37.4803887400743,
    "lng": 126.882643680055
  },
  {
    "name": "철산",
    "lat": 37.4761928323657,
    "lng": 126.868201982739
  },
  {
    "name": "광명사거리",
    "lat": 37.4792946820271,
    "lng": 126.85485565284
  },
  {
    "name": "천왕",
    "lat": 37.4868420352704,
    "lng": 126.838581632594
  },
  {
    "name": "온수",
    "lat": 37.4919566907461,
    "lng": 126.823825338009
  },
  {
    "name": "까치울",
    "lat": 37.5062093130608,
    "lng": 126.811328358368
  },
  {
    "name": "부천종합운동장",
    "lat": 37.5054110660251,
    "lng": 126.797215785441
  },
  {
    "name": "신중동",
    "lat": 37.5029417111885,
    "lng": 126.776888189294
  },
  {
    "name": "부천시청",
    "lat": 37.5046286887108,
    "lng": 126.764058041258
  },
  {
    "name": "삼산체육관",
    "lat": 37.5064914068797,
    "lng": 126.741409731627
  },
  {
    "name": "굴포천",
    "lat": 37.5070275598449,
    "lng": 126.731341990324
  },
  {
    "name": "부평구청",
    "lat": 37.507419068537,
    "lng": 126.721432985599
  },
  {
    "name": "암사",
    "lat": 37.550133857734,
    "lng": 127.127537293281
  },
  {
    "name": "공릉",
    "lat": 37.6255391693239,
    "lng": 127.073019988267
  },
  {
    "name": "춘의",
    "lat": 37.5036811739172,
    "lng": 126.786996678208
  },
  {
    "name": "천호",
    "lat": 37.5384968055586,
    "lng": 127.123919374783
  },
  {
    "name": "강동구청",
    "lat": 37.530193178362,
    "lng": 127.120443701344
  },
  {
    "name": "몽촌토성",
    "lat": 37.5178028959182,
    "lng": 127.112844983956
  },
  {
    "name": "잠실",
    "lat": 37.5133092702048,
    "lng": 127.100215181119
  },
  {
    "name": "석촌",
    "lat": 37.5054105299706,
    "lng": 127.106990485844
  },
  {
    "name": "송파",
    "lat": 37.4997113580808,
    "lng": 127.112184453853
  },
  {
    "name": "가락시장",
    "lat": 37.493092048704,
    "lng": 127.118258210622
  },
  {
    "name": "문정",
    "lat": 37.4860238552656,
    "lng": 127.122475829669
  },
  {
    "name": "장지",
    "lat": 37.478631698139,
    "lng": 127.126172045084
  },
  {
    "name": "복정",
    "lat": 37.4707382891863,
    "lng": 127.126701394602
  },
  {
    "name": "산성",
    "lat": 37.4567993089902,
    "lng": 127.150073936897
  },
  {
    "name": "남한산성입구",
    "lat": 37.4516687091001,
    "lng": 127.159873536458
  },
  {
    "name": "단대오거리",
    "lat": 37.4450233989513,
    "lng": 127.156763011663
  },
  {
    "name": "신흥",
    "lat": 37.4409086355148,
    "lng": 127.147533584341
  },
  {
    "name": "수진",
    "lat": 37.4373671826853,
    "lng": 127.140520928805
  },
  {
    "name": "모란",
    "lat": 37.4340274873996,
    "lng": 127.129961399904
  },
  {
    "name": "계양",
    "lat": 37.5717663371129,
    "lng": 126.736271428893
  },
  {
    "name": "귤현",
    "lat": 37.5662844094145,
    "lng": 126.742674641657
  },
  {
    "name": "박촌",
    "lat": 37.5536576166972,
    "lng": 126.745049372602
  },
  {
    "name": "임학",
    "lat": 37.5449940157494,
    "lng": 126.738628916225
  },
  {
    "name": "계산",
    "lat": 37.5432935271122,
    "lng": 126.727726743177
  },
  {
    "name": "경인교대입구",
    "lat": 37.5381098916945,
    "lng": 126.722608726884
  },
  {
    "name": "작전",
    "lat": 37.5302530435772,
    "lng": 126.722547318021
  },
  {
    "name": "갈산",
    "lat": 37.5171140794594,
    "lng": 126.72153268891
  },
  {
    "name": "부평구청",
    "lat": 37.507419068537,
    "lng": 126.721432985599
  },
  {
    "name": "부평시장",
    "lat": 37.4983569756961,
    "lng": 126.72228087721
  },
  {
    "name": "부평",
    "lat": 37.4894418243737,
    "lng": 126.724326592211
  },
  {
    "name": "동수",
    "lat": 37.4854999340719,
    "lng": 126.718597252565
  },
  {
    "name": "부평삼거리",
    "lat": 37.4778212873274,
    "lng": 126.710282528362
  },
  {
    "name": "인천시청",
    "lat": 37.4577267935147,
    "lng": 126.702222226296
  },
  {
    "name": "예술회관",
    "lat": 37.4485151381953,
    "lng": 126.700902602702
  },
  {
    "name": "인천터미널",
    "lat": 37.4419166504208,
    "lng": 126.699685849828
  },
  {
    "name": "상동",
    "lat": 37.5057777528781,
    "lng": 126.753174390302
  },
  {
    "name": "문학경기장",
    "lat": 37.434633323328,
    "lng": 126.698449455888
  },
  {
    "name": "선학",
    "lat": 37.4269398417713,
    "lng": 126.698909636823
  },
  {
    "name": "신연수",
    "lat": 37.4180973429852,
    "lng": 126.694019725957
  },
  {
    "name": "원인재",
    "lat": 37.4123688424567,
    "lng": 126.68787555936
  },
  {
    "name": "동춘",
    "lat": 37.4045652705741,
    "lng": 126.680837538983
  },
  {
    "name": "동막",
    "lat": 37.3979315880858,
    "lng": 126.673434509395
  },
  {
    "name": "캠퍼스타운",
    "lat": 37.3884393522901,
    "lng": 126.6622061372
  },
  {
    "name": "테크노파크",
    "lat": 37.3822773662676,
    "lng": 126.65629460478
  },
  {
    "name": "지식정보단지",
    "lat": 37.3774891987682,
    "lng": 126.645861465756
  },
  {
    "name": "인천대입구",
    "lat": 37.3861919071819,
    "lng": 126.639519720247
  },
  {
    "name": "센트럴파크",
    "lat": 37.3928454874914,
    "lng": 126.634970746765
  },
  {
    "name": "국제업무지구",
    "lat": 37.3996433943868,
    "lng": 126.630533193969
  },
  {
    "name": "검단사거리",
    "lat": 37.6016539690002,
    "lng": 126.656420307251
  },
  {
    "name": "마전",
    "lat": 37.5976304703003,
    "lng": 126.667218943756
  },
  {
    "name": "독정",
    "lat": 37.5848428291863,
    "lng": 126.675993614924
  },
  {
    "name": "검암",
    "lat": 37.5692492054082,
    "lng": 126.673638828703
  },
  {
    "name": "검바위",
    "lat": 37.5611149059147,
    "lng": 126.67752248339
  },
  {
    "name": "서구청",
    "lat": 37.5440301501202,
    "lng": 126.676826630599
  },
  {
    "name": "가정",
    "lat": 37.5248168370742,
    "lng": 126.675348382289
  },
  {
    "name": "석남",
    "lat": 37.5074661446109,
    "lng": 126.676283101193
  },
  {
    "name": "서부여성회관",
    "lat": 37.5003290546645,
    "lng": 126.675861556848
  },
  {
    "name": "인천가좌",
    "lat": 37.4898216199472,
    "lng": 126.675228523206
  },
  {
    "name": "가재울",
    "lat": 37.4841323844532,
    "lng": 126.683755657306
  },
  {
    "name": "주안국가산단",
    "lat": 37.473908169022,
    "lng": 126.681221205002
  },
  {
    "name": "주안",
    "lat": 37.4650388163816,
    "lng": 126.679947643466
  },
  {
    "name": "시민공원",
    "lat": 37.4583743653314,
    "lng": 126.68106110186
  },
  {
    "name": "석바위시장",
    "lat": 37.4576654498643,
    "lng": 126.692344047203
  },
  {
    "name": "인천시청",
    "lat": 37.4577267935147,
    "lng": 126.702222226296
  },
  {
    "name": "석천사거리",
    "lat": 37.4567740479476,
    "lng": 126.710408949459
  },
  {
    "name": "모래내시장",
    "lat": 37.455859192036,
    "lng": 126.719612529317
  },
  {
    "name": "만수",
    "lat": 37.454968293444,
    "lng": 126.731731753788
  },
  {
    "name": "인천대공원",
    "lat": 37.4484729876328,
    "lng": 126.752842934744
  },
  {
    "name": "운연",
    "lat": 37.43963899493,
    "lng": 126.759606699327
  },
  {
    "name": "개화",
    "lat": 37.5783372913891,
    "lng": 126.796882325598
  },
  {
    "name": "김포공항",
    "lat": 37.5619477391215,
    "lng": 126.801906881417
  },
  {
    "name": "공항시장",
    "lat": 37.5636738875486,
    "lng": 126.810594967667
  },
  {
    "name": "신방화",
    "lat": 37.567486525915,
    "lng": 126.817218331242
  },
  {
    "name": "마곡나루",
    "lat": 37.5667089856741,
    "lng": 126.827407353953
  },
  {
    "name": "양천향교",
    "lat": 37.5680628368766,
    "lng": 126.841960762674
  },
  {
    "name": "증미",
    "lat": 37.5581213429662,
    "lng": 126.860633381512
  },
  {
    "name": "등촌",
    "lat": 37.5507208571932,
    "lng": 126.865558572269
  },
  {
    "name": "선유도",
    "lat": 37.5381532418967,
    "lng": 126.89332482044
  },
  {
    "name": "왕길",
    "lat": 37.595125452058,
    "lng": 126.642477389389
  },
  {
    "name": "완정",
    "lat": 37.5928353956603,
    "lng": 126.673014999848
  },
  {
    "name": "염창",
    "lat": 37.5469649168106,
    "lng": 126.874867107681
  },
  {
    "name": "신목동",
    "lat": 37.5442703452459,
    "lng": 126.883086765892
  },
  {
    "name": "당산",
    "lat": 37.5347735014069,
    "lng": 126.902607283905
  },
  {
    "name": "국회의사당",
    "lat": 37.5281356801658,
    "lng": 126.917820861804
  },
  {
    "name": "여의도",
    "lat": 37.5211664706025,
    "lng": 126.924638422261
  },
  {
    "name": "샛강",
    "lat": 37.517366563071,
    "lng": 126.92837506516
  },
  {
    "name": "노량진",
    "lat": 37.5135712531779,
    "lng": 126.940888666744
  },
  {
    "name": "노들",
    "lat": 37.5126577019678,
    "lng": 126.953082505556
  },
  {
    "name": "흑석",
    "lat": 37.5091654663414,
    "lng": 126.96344496646
  },
  {
    "name": "동작",
    "lat": 37.5029705640491,
    "lng": 126.980299007575
  },
  {
    "name": "구반포",
    "lat": 37.5014218099211,
    "lng": 126.987446814026
  },
  {
    "name": "신반포",
    "lat": 37.5034947245635,
    "lng": 126.996064297745
  },
  {
    "name": "고속터미널",
    "lat": 37.5045398449292,
    "lng": 127.005134579686
  },
  {
    "name": "사평",
    "lat": 37.50423262798,
    "lng": 127.015267960691
  },
  {
    "name": "신논현",
    "lat": 37.5048075124198,
    "lng": 127.025469415506
  },
  {
    "name": "석촌고분",
    "lat": 37.5024642758104,
    "lng": 127.096491224145
  },
  {
    "name": "석촌",
    "lat": 37.5054105299706,
    "lng": 127.106990485844
  },
  {
    "name": "송파나루",
    "lat": 37.5110095122823,
    "lng": 127.112653785965
  },
  {
    "name": "한성백제",
    "lat": 37.5165199821667,
    "lng": 127.116440092824
  },
  {
    "name": "올림픽공원",
    "lat": 37.5163245709914,
    "lng": 127.130963650207
  },
  {
    "name": "둔촌오륜",
    "lat": 37.5193972411893,
    "lng": 127.138638475396
  },
  {
    "name": "중앙보훈병원",
    "lat": 37.5283953876669,
    "lng": 127.148407138571
  },
  {
    "name": "마곡나루",
    "lat": 37.5667089856741,
    "lng": 126.827407353953
  },
  {
    "name": "김포공항",
    "lat": 37.5619477391215,
    "lng": 126.801906881417
  },
  {
    "name": "계양",
    "lat": 37.5717663371129,
    "lng": 126.736271428893
  },
  {
    "name": "검암",
    "lat": 37.5692492054082,
    "lng": 126.673638828703
  },
  {
    "name": "정자",
    "lat": 37.3661666006259,
    "lng": 127.108079384783
  },
  {
    "name": "미금",
    "lat": 37.3500734029357,
    "lng": 127.109004370819
  },
  {
    "name": "동천",
    "lat": 37.3378249132707,
    "lng": 127.102847846954
  },
  {
    "name": "수지구청",
    "lat": 37.3224781677918,
    "lng": 127.094658542513
  },
  {
    "name": "성복",
    "lat": 37.3135144427628,
    "lng": 127.080365602442
  },
  {
    "name": "상현",
    "lat": 37.2978253754142,
    "lng": 127.069340973557
  },
  {
    "name": "광교중앙",
    "lat": 37.2883734932387,
    "lng": 127.05171729556
  },
  {
    "name": "새말",
    "lat": 37.7488342825137,
    "lng": 127.063745883251
  },
  {
    "name": "경기도청북부청사",
    "lat": 37.7507578441673,
    "lng": 127.07159966714
  },
  {
    "name": "곤제",
    "lat": 37.7505335628569,
    "lng": 127.083808800706
  },
  {
    "name": "가양",
    "lat": 37.5614294894973,
    "lng": 126.854402192224
  },
  {
    "name": "선정릉",
    "lat": 37.5109290398758,
    "lng": 127.043613714302
  },
  {
    "name": "삼성중앙",
    "lat": 37.5129614592575,
    "lng": 127.053025579452
  },
  {
    "name": "봉은사",
    "lat": 37.5142374358367,
    "lng": 127.060220347306
  },
  {
    "name": "종합운동장",
    "lat": 37.5111302556967,
    "lng": 127.07383586044
  },
  {
    "name": "삼전",
    "lat": 37.5045436968849,
    "lng": 127.08735570822
  },
  {
    "name": "서울",
    "lat": 37.5533163107152,
    "lng": 126.969738305903
  },
  {
    "name": "공덕",
    "lat": 37.5445344743163,
    "lng": 126.95143307723
  },
  {
    "name": "홍대입구",
    "lat": 37.5568635281461,
    "lng": 126.923764988566
  },
  {
    "name": "디지털미디어시티",
    "lat": 37.5760020219691,
    "lng": 126.901263083061
  },
  {
    "name": "청라국제도시",
    "lat": 37.5564536766415,
    "lng": 126.624644887111
  },
  {
    "name": "운서",
    "lat": 37.4928052601709,
    "lng": 126.493725443401
  },
  {
    "name": "양재시민의숲",
    "lat": 37.4701151903454,
    "lng": 127.038457766798
  },
  {
    "name": "판교",
    "lat": 37.3947622153025,
    "lng": 127.111192160375
  },
  {
    "name": "광교",
    "lat": 37.3021083255958,
    "lng": 127.044259827576
  },
  {
    "name": "회룡",
    "lat": 37.7237950762834,
    "lng": 127.047277212627
  },
  {
    "name": "범골",
    "lat": 37.7287878565888,
    "lng": 127.043650414579
  },
  {
    "name": "경전철의정부",
    "lat": 37.7372571103071,
    "lng": 127.043292348168
  },
  {
    "name": "의정부시청",
    "lat": 37.7392240282409,
    "lng": 127.034829933565
  },
  {
    "name": "흥선",
    "lat": 37.7432776750286,
    "lng": 127.037169082949
  },
  {
    "name": "의정부중앙",
    "lat": 37.7436695049384,
    "lng": 127.0496498053
  },
  {
    "name": "공항화물청사",
    "lat": 37.4590552168484,
    "lng": 126.477496372804
  },
  {
    "name": "인천공항1터미널",
    "lat": 37.4475177072398,
    "lng": 126.452578974301
  },
  {
    "name": "인천공항2터미널",
    "lat": 37.4687821735189,
    "lng": 126.433636502678
  },
  {
    "name": "영종",
    "lat": 37.51201816208,
    "lng": 126.524971484378
  },
  {
    "name": "강남",
    "lat": 37.4980854411503,
    "lng": 127.027977657727
  },
  {
    "name": "양재",
    "lat": 37.4845687081114,
    "lng": 127.034146039501
  },
  {
    "name": "강남대",
    "lat": 37.2701707463678,
    "lng": 127.126048852907
  },
  {
    "name": "지석",
    "lat": 37.2697264896226,
    "lng": 127.13664607007
  },
  {
    "name": "어정",
    "lat": 37.2749441263938,
    "lng": 127.143736325862
  },
  {
    "name": "동백",
    "lat": 37.2690941934817,
    "lng": 127.152677020642
  },
  {
    "name": "초당",
    "lat": 37.2607956916315,
    "lng": 127.15944666798
  },
  {
    "name": "시청.용인대",
    "lat": 37.2394312311549,
    "lng": 127.178876050309
  },
  {
    "name": "명지대",
    "lat": 37.2380618930876,
    "lng": 127.19027774875
  },
  {
    "name": "김량장",
    "lat": 37.2373093842642,
    "lng": 127.198592810314
  },
  {
    "name": "운동장.송담대",
    "lat": 37.2379039726401,
    "lng": 127.209120242573
  },
  {
    "name": "고진",
    "lat": 37.2446347645105,
    "lng": 127.214165558244
  },
  {
    "name": "보평",
    "lat": 37.2590435821757,
    "lng": 127.218467470786
  },
  {
    "name": "둔전",
    "lat": 37.2671978333453,
    "lng": 127.213620643705
  },
  {
    "name": "발곡",
    "lat": 37.7271442784747,
    "lng": 127.052951047249
  },
  {
    "name": "송산",
    "lat": 37.7372688479978,
    "lng": 127.087197331244
  },
  {
    "name": "탑석",
    "lat": 37.7334835070595,
    "lng": 127.088894548309
  },
  {
    "name": "북한산우이",
    "lat": 37.6629879523308,
    "lng": 127.012739014317
  },
  {
    "name": "솔밭공원",
    "lat": 37.655978257268,
    "lng": 127.013259115174
  },
  {
    "name": "4·19민주묘지",
    "lat": 37.6495271717567,
    "lng": 127.013688568881
  },
  {
    "name": "가오리",
    "lat": 37.6416341556655,
    "lng": 127.01676898865
  },
  {
    "name": "삼양사거리",
    "lat": 37.6213073258081,
    "lng": 127.020479780253
  },
  {
    "name": "솔샘",
    "lat": 37.6202451573205,
    "lng": 127.013569926861
  },
  {
    "name": "북한산보국문",
    "lat": 37.6121187346003,
    "lng": 127.008245268539
  },
  {
    "name": "정릉",
    "lat": 37.6026037968404,
    "lng": 127.013521423935
  },
  {
    "name": "성신여대입구",
    "lat": 37.5929627242628,
    "lng": 127.017120398018
  },
  {
    "name": "보문",
    "lat": 37.5855380945306,
    "lng": 127.019994457457
  },
  {
    "name": "오리",
    "lat": 37.3398197437914,
    "lng": 127.108944410482
  },
  {
    "name": "간석오거리",
    "lat": 37.4670754270052,
    "lng": 126.707904954236
  },
  {
    "name": "종로3가",
    "lat": 37.5704208439207,
    "lng": 126.992144196794
  },
  {
    "name": "종로5가",
    "lat": 37.5709616924446,
    "lng": 127.001539476891
  },
  {
    "name": "동대문",
    "lat": 37.5716640012581,
    "lng": 127.010617962363
  },
  {
    "name": "신설동",
    "lat": 37.5760227613002,
    "lng": 127.024452169845
  },
  {
    "name": "제기동",
    "lat": 37.5781644906615,
    "lng": 127.034935905941
  },
  {
    "name": "청량리",
    "lat": 37.5807185198462,
    "lng": 127.048499848096
  },
  {
    "name": "동묘앞",
    "lat": 37.5732130585579,
    "lng": 127.016346114277
  },
  {
    "name": "대곡",
    "lat": 37.631681128995,
    "lng": 126.810920972324
  },
  {
    "name": "충무로",
    "lat": 37.5613929793562,
    "lng": 126.994137154178
  },
  {
    "name": "죽전",
    "lat": 37.324377387157,
    "lng": 127.107500507614
  },
  {
    "name": "청계산입구",
    "lat": 37.4483403225219,
    "lng": 127.054720316678
  },
  {
    "name": "신설동",
    "lat": 37.5760227613002,
    "lng": 127.024452169845
  },
  {
    "name": "소사",
    "lat": 37.482793087788,
    "lng": 126.795626202003
  },
  {
    "name": "소새울",
    "lat": 37.4685059275196,
    "lng": 126.797270299654
  },
  {
    "name": "시흥대야",
    "lat": 37.450099848927,
    "lng": 126.792980234554
  },
  {
    "name": "신천",
    "lat": 37.439240616729,
    "lng": 126.786772666879
  },
  {
    "name": "신현",
    "lat": 37.409563047498,
    "lng": 126.787828208206
  },
  {
    "name": "시흥시청",
    "lat": 37.3815543779072,
    "lng": 126.805927791575
  },
  {
    "name": "시흥능곡",
    "lat": 37.3699357078736,
    "lng": 126.808712336392
  },
  {
    "name": "달미",
    "lat": 37.3487807176154,
    "lng": 126.809398048906
  },
  {
    "name": "선부",
    "lat": 37.3344012244658,
    "lng": 126.809976021899
  },
  {
    "name": "초지",
    "lat": 37.3206629744686,
    "lng": 126.80594908949
  },
  {
    "name": "원곡",
    "lat": 37.3131491759147,
    "lng": 126.795725352292
  },
  {
    "name": "원시",
    "lat": 37.3026093136252,
    "lng": 126.786775526256
  },
  {
    "name": "양촌",
    "lat": 37.6417268910766,
    "lng": 126.614676098923
  },
  {
    "name": "구래",
    "lat": 37.6452652583848,
    "lng": 126.627937619328
  },
  {
    "name": "마산",
    "lat": 35.2362020956079,
    "lng": 128.577168715535
  },
  {
    "name": "장기",
    "lat": 37.644054370351,
    "lng": 126.669074138552
  },
  {
    "name": "운양",
    "lat": 37.6537713637391,
    "lng": 126.683830867772
  },
  {
    "name": "걸포북변",
    "lat": 37.6316279949669,
    "lng": 126.705789359074
  },
  {
    "name": "사우",
    "lat": 37.6200048459257,
    "lng": 126.720424444576
  },
  {
    "name": "풍무",
    "lat": 37.6126624208995,
    "lng": 126.732344200216
  },
  {
    "name": "고촌",
    "lat": 37.6012098003045,
    "lng": 126.77032142847
  },
  {
    "name": "김포공항",
    "lat": 37.5619477391215,
    "lng": 126.801906881417
  },
  {
    "name": "서초",
    "lat": 37.491835518946,
    "lng": 127.007644026196
  },
  {
    "name": "이매",
    "lat": 37.3947099349286,
    "lng": 127.12729606911
  },
  {
    "name": "소요산",
    "lat": 37.9488831816783,
    "lng": 127.061119494763
  },
  {
    "name": "남동구청",
    "lat": 37.4481674840897,
    "lng": 126.736547716768
  },
  {
    "name": "왕십리",
    "lat": 37.5612611631671,
    "lng": 127.037078472459
  },
  {
    "name": "판교",
    "lat": 37.3947622153025,
    "lng": 127.111192160375
  },
  {
    "name": "신포",
    "lat": 37.468443681084,
    "lng": 126.624520175227
  },
  {
    "name": "신내",
    "lat": 37.612487415788,
    "lng": 127.104266904089
  },
  {
    "name": "상왕십리",
    "lat": 37.5644348647729,
    "lng": 127.029270145908
  },
  {
    "name": "삼가",
    "lat": 37.2420419195264,
    "lng": 127.168175442278
  },
  {
    "name": "한남",
    "lat": 37.5294253166994,
    "lng": 127.009186483335
  },
  {
    "name": "지제",
    "lat": 37.0187673944311,
    "lng": 127.069828230286
  },
  {
    "name": "전대.에버랜드",
    "lat": 37.2854603654967,
    "lng": 127.219378294699
  },
  {
    "name": "대림",
    "lat": 37.4933027323738,
    "lng": 126.894926522974
  },
  {
    "name": "아시아드경기장",
    "lat": 37.5513109096011,
    "lng": 126.677089429261
  },
  {
    "name": "신설동",
    "lat": 37.5760227613002,
    "lng": 127.024452169845
  },
  {
    "name": "도림천",
    "lat": 37.5145008199738,
    "lng": 126.882635530518
  },
  {
    "name": "양천구청",
    "lat": 37.5123744505094,
    "lng": 126.865717870736
  },
  {
    "name": "용두",
    "lat": 37.5740549248114,
    "lng": 127.038262110343
  },
  {
    "name": "중랑",
    "lat": 37.5948317972278,
    "lng": 127.075662270251
  },
  {
    "name": "기흥",
    "lat": 37.2754420734533,
    "lng": 127.117037420103
  },
  {
    "name": "검단오류",
    "lat": 37.5949362180671,
    "lng": 126.627893943162
  },
  {
    "name": "용산",
    "lat": 37.5300691538724,
    "lng": 126.964815014401
  },
  {
    "name": "수원",
    "lat": 37.2657867038031,
    "lng": 127.000090190749
  },
  {
    "name": "화정",
    "lat": 37.634633161962,
    "lng": 126.832665788035
  },
  {
    "name": "언주",
    "lat": 37.5073281931356,
    "lng": 127.033952822224
  },
  {
    "name": "기흥",
    "lat": 37.2754420734533,
    "lng": 127.117037420103
  },
  {
    "name": "서울",
    "lat": 37.5533163107152,
    "lng": 126.969738305903
  },
  {
    "name": "시청",
    "lat": 37.5653372841193,
    "lng": 126.977181235023
  },
  {
    "name": "종각",
    "lat": 37.5702216815202,
    "lng": 126.983133839231
  },
  {
    "name": "화계",
    "lat": 37.6340837961475,
    "lng": 127.017492363882
  },
  {
    "name": "삼양",
    "lat": 37.6269118474291,
    "lng": 127.018147716421
  },
  {
    "name": "회기",
    "lat": 37.5897782042758,
    "lng": 127.058039297256
  },
  {
    "name": "가좌",
    "lat": 37.5687505576544,
    "lng": 126.914810592109
  },
  {
    "name": "괴정",
    "lat": 35.0999289032165,
    "lng": 128.992469504766
  },
  {
    "name": "교대",
    "lat": 35.195783907898,
    "lng": 129.079977005358
  },
  {
    "name": "구서",
    "lat": 35.2472788571844,
    "lng": 129.091288232766
  },
  {
    "name": "남산",
    "lat": 35.2651922446799,
    "lng": 129.092407860564
  },
  {
    "name": "남포",
    "lat": 35.0978931395507,
    "lng": 129.034723258276
  },
  {
    "name": "낫개",
    "lat": 35.0653349861198,
    "lng": 128.97965901275
  },
  {
    "name": "노포",
    "lat": 35.2838366796016,
    "lng": 129.095019665866
  },
  {
    "name": "다대포항",
    "lat": 35.0576668950612,
    "lng": 128.971297843707
  },
  {
    "name": "다대포해수욕장",
    "lat": 35.0481499885694,
    "lng": 128.965765148499
  },
  {
    "name": "당리",
    "lat": 35.1035524449391,
    "lng": 128.973696338125
  },
  {
    "name": "대티",
    "lat": 35.1031582649819,
    "lng": 128.99993908601
  },
  {
    "name": "동대신",
    "lat": 35.110325161267,
    "lng": 129.017726862246
  },
  {
    "name": "동래",
    "lat": 35.2056143204332,
    "lng": 129.07847104597
  },
  {
    "name": "동매",
    "lat": 35.0897491881322,
    "lng": 128.973517094459
  },
  {
    "name": "두실",
    "lat": 35.2570099271141,
    "lng": 129.091362493563
  },
  {
    "name": "명륜",
    "lat": 35.2125680814846,
    "lng": 129.079702455864
  },
  {
    "name": "범내골",
    "lat": 35.1473136702701,
    "lng": 129.059234944968
  },
  {
    "name": "범어사",
    "lat": 35.2730643367497,
    "lng": 129.09263234654
  },
  {
    "name": "범일",
    "lat": 35.1407875618323,
    "lng": 129.059333803704
  },
  {
    "name": "부산",
    "lat": 35.1151013523834,
    "lng": 129.041402536451
  },
  {
    "name": "부산대",
    "lat": 35.2296488891639,
    "lng": 129.089407790192
  },
  {
    "name": "부산진",
    "lat": 35.1287873021046,
    "lng": 129.04957613438
  },
  {
    "name": "부전",
    "lat": 35.1646371421327,
    "lng": 129.060110661449
  },
  {
    "name": "사하",
    "lat": 35.0997534720429,
    "lng": 128.983385888261
  },
  {
    "name": "서대신",
    "lat": 35.1109049242578,
    "lng": 129.012126142414
  },
  {
    "name": "서면",
    "lat": 35.1579285516114,
    "lng": 129.059283061675
  },
  {
    "name": "시청",
    "lat": 35.1796758702172,
    "lng": 129.076558991487
  },
  {
    "name": "신장림",
    "lat": 35.0747396347519,
    "lng": 128.976575670276
  },
  {
    "name": "신평",
    "lat": 35.09522174177,
    "lng": 128.96060084695
  },
  {
    "name": "양정",
    "lat": 35.1727945202072,
    "lng": 129.071093977333
  },
  {
    "name": "연산",
    "lat": 35.186023648491,
    "lng": 129.081594219508
  },
  {
    "name": "온천장",
    "lat": 35.2202563844313,
    "lng": 129.086421592963
  },
  {
    "name": "자갈치",
    "lat": 35.0971910773904,
    "lng": 129.026065425464
  },
  {
    "name": "장림",
    "lat": 35.0819546708467,
    "lng": 128.977341757158
  },
  {
    "name": "장전",
    "lat": 35.2380696359538,
    "lng": 129.088130026335
  },
  {
    "name": "좌천",
    "lat": 35.3112993353273,
    "lng": 129.243854152013
  },
  {
    "name": "중앙",
    "lat": 35.1037232889884,
    "lng": 129.036359539834
  },
  {
    "name": "초량",
    "lat": 35.1205232890849,
    "lng": 129.042656589057
  },
  {
    "name": "토성",
    "lat": 35.1007746620673,
    "lng": 129.019772229835
  },
  {
    "name": "하단",
    "lat": 35.1062241549739,
    "lng": 128.966786200409
  },
  {
    "name": "가야",
    "lat": 35.1559283350274,
    "lng": 129.043300138953
  },
  {
    "name": "감전",
    "lat": 35.1553317654515,
    "lng": 128.991471695099
  },
  {
    "name": "개금",
    "lat": 35.1532278026698,
    "lng": 129.020563458407
  },
  {
    "name": "경성대.부경대",
    "lat": 35.13759348154,
    "lng": 129.100501514097
  },
  {
    "name": "광안",
    "lat": 35.1578479276108,
    "lng": 129.113136364282
  },
  {
    "name": "구남",
    "lat": 35.1966759799094,
    "lng": 128.994851970683
  },
  {
    "name": "구명",
    "lat": 35.2027985510549,
    "lng": 128.999547136349
  },
  {
    "name": "금곡",
    "lat": 35.2672336674807,
    "lng": 129.016798392946
  },
  {
    "name": "금련산",
    "lat": 35.1497396076358,
    "lng": 129.11095170431
  },
  {
    "name": "남양산",
    "lat": 35.3254405539145,
    "lng": 129.019409064815
  },
  {
    "name": "남천",
    "lat": 35.1420079376654,
    "lng": 129.107833750696
  },
  {
    "name": "냉정",
    "lat": 35.1512417787151,
    "lng": 129.012109601668
  },
  {
    "name": "대연",
    "lat": 35.1351254985673,
    "lng": 129.092100980224
  },
  {
    "name": "덕천",
    "lat": 35.2104197091066,
    "lng": 129.005158287856
  },
  {
    "name": "덕포",
    "lat": 35.1733191555408,
    "lng": 128.983788688479
  },
  {
    "name": "동백",
    "lat": 35.1613259416941,
    "lng": 129.147989867891
  },
  {
    "name": "동원",
    "lat": 35.2586376256915,
    "lng": 129.012410371979
  },
  {
    "name": "동의대",
    "lat": 35.1540539311131,
    "lng": 129.032587914321
  },
  {
    "name": "모덕",
    "lat": 35.1804089764856,
    "lng": 128.985585488941
  },
  {
    "name": "모라",
    "lat": 35.1895342232958,
    "lng": 128.988551913229
  },
  {
    "name": "못골",
    "lat": 35.1347181113768,
    "lng": 129.084367776273
  },
  {
    "name": "문현",
    "lat": 35.1390283109348,
    "lng": 129.067385703111
  },
  {
    "name": "민락",
    "lat": 35.1670633468974,
    "lng": 129.122088298688
  },
  {
    "name": "벡스코",
    "lat": 35.1712399344204,
    "lng": 129.136705372018
  },
  {
    "name": "부산대양산캠퍼스",
    "lat": 35.3168079697557,
    "lng": 129.013982914868
  },
  {
    "name": "부암",
    "lat": 35.1573623855935,
    "lng": 129.050161215715
  },
  {
    "name": "사상",
    "lat": 35.16256857145,
    "lng": 128.988707163177
  },
  {
    "name": "서면",
    "lat": 35.1579285516114,
    "lng": 129.059283061675
  },
  {
    "name": "센텀시티",
    "lat": 35.1689482384046,
    "lng": 129.131750834403
  },
  {
    "name": "수영",
    "lat": 35.1656767583149,
    "lng": 129.114809457656
  },
  {
    "name": "수정",
    "lat": 35.223168959538,
    "lng": 129.009096017616
  },
  {
    "name": "양산",
    "lat": 35.3387321483244,
    "lng": 129.026426348711
  },
  {
    "name": "율리",
    "lat": 35.2462483723543,
    "lng": 129.012851066753
  },
  {
    "name": "장산",
    "lat": 35.1699451806126,
    "lng": 129.177013481526
  },
  {
    "name": "전포",
    "lat": 35.1530847640144,
    "lng": 129.065371326357
  },
  {
    "name": "주례",
    "lat": 35.1504756571399,
    "lng": 129.002874118914
  },
  {
    "name": "중동",
    "lat": 35.1666689389201,
    "lng": 129.168761506199
  },
  {
    "name": "증산",
    "lat": 35.3082546899949,
    "lng": 129.010274899651
  },
  {
    "name": "지게골",
    "lat": 35.1355559610514,
    "lng": 129.0744064496
  },
  {
    "name": "해운대",
    "lat": 35.1636372334733,
    "lng": 129.158892567131
  },
  {
    "name": "호포",
    "lat": 35.2808292528308,
    "lng": 129.017509213349
  },
  {
    "name": "화명",
    "lat": 35.2345117225299,
    "lng": 129.007640378398
  },
  {
    "name": "강서구청",
    "lat": 35.2111798817285,
    "lng": 128.981986450564
  },
  {
    "name": "거제",
    "lat": 35.1884955700528,
    "lng": 129.074083076729
  },
  {
    "name": "구포",
    "lat": 35.2054702088577,
    "lng": 128.997109305675
  },
  {
    "name": "남산정",
    "lat": 35.2133185169813,
    "lng": 129.023742898721
  },
  {
    "name": "대저",
    "lat": 35.2130418747464,
    "lng": 128.96061942008
  },
  {
    "name": "덕천",
    "lat": 35.2104197091066,
    "lng": 129.005158287856
  },
  {
    "name": "만덕",
    "lat": 35.2130001731867,
    "lng": 129.036274760209
  },
  {
    "name": "망미",
    "lat": 35.1714853849008,
    "lng": 129.108309225102
  },
  {
    "name": "물만골",
    "lat": 35.1767971667486,
    "lng": 129.085705198123
  },
  {
    "name": "미남",
    "lat": 35.206840434349,
    "lng": 129.068972012147
  },
  {
    "name": "배산",
    "lat": 35.1734909178456,
    "lng": 129.09556412768
  },
  {
    "name": "사직",
    "lat": 35.1986144950882,
    "lng": 129.065184316341
  },
  {
    "name": "수영",
    "lat": 35.1656767583149,
    "lng": 129.114809457656
  },
  {
    "name": "숙등",
    "lat": 35.2120706372117,
    "lng": 129.013192665463
  },
  {
    "name": "연산",
    "lat": 35.186023648491,
    "lng": 129.081594219508
  },
  {
    "name": "종합운동장",
    "lat": 35.191547306926,
    "lng": 129.067420452102
  },
  {
    "name": "체육공원",
    "lat": 35.2124665544821,
    "lng": 128.96941202744
  },
  {
    "name": "고촌",
    "lat": 35.2360066637924,
    "lng": 129.160457828198
  },
  {
    "name": "금사",
    "lat": 35.2157751111313,
    "lng": 129.115120329092
  },
  {
    "name": "낙민",
    "lat": 35.2002120135147,
    "lng": 129.09076121312
  },
  {
    "name": "동래",
    "lat": 35.2056143204332,
    "lng": 129.07847104597
  },
  {
    "name": "동부산대학",
    "lat": 35.2323775475617,
    "lng": 129.153749889572
  },
  {
    "name": "명장",
    "lat": 35.2054084185253,
    "lng": 129.101873805387
  },
  {
    "name": "미남",
    "lat": 35.206840434349,
    "lng": 129.068972012147
  },
  {
    "name": "반여농산물시장",
    "lat": 35.2177466632227,
    "lng": 129.123978226851
  },
  {
    "name": "서동",
    "lat": 35.2131682261581,
    "lng": 129.107520151787
  },
  {
    "name": "석대",
    "lat": 35.2181299760922,
    "lng": 129.137011666198
  },
  {
    "name": "수안",
    "lat": 35.2017371696674,
    "lng": 129.083839707608
  },
  {
    "name": "안평",
    "lat": 35.3339439952575,
    "lng": 126.780258248189
  },
  {
    "name": "영산대",
    "lat": 35.2255927079761,
    "lng": 129.14610278873
  },
  {
    "name": "충렬사",
    "lat": 35.2000368312143,
    "lng": 129.097761089153
  },
  {
    "name": "국제금융센터.부산은행",
    "lat": 35.1459064311736,
    "lng": 129.066725875342
  },
  {
    "name": "각산",
    "lat": 35.8679872102015,
    "lng": 128.724240457388
  },
  {
    "name": "교대",
    "lat": 35.8506373634688,
    "lng": 128.590576155881
  },
  {
    "name": "대곡",
    "lat": 35.8095583458704,
    "lng": 128.512757168817
  },
  {
    "name": "대구",
    "lat": 35.8759381314361,
    "lng": 128.596263696332
  },
  {
    "name": "대명",
    "lat": 35.839318216829,
    "lng": 128.565935871083
  },
  {
    "name": "동대구역",
    "lat": 35.8775500832393,
    "lng": 128.627896847145
  },
  {
    "name": "동촌",
    "lat": 35.8860579139277,
    "lng": 128.650262490859
  },
  {
    "name": "명덕",
    "lat": 35.8578216212265,
    "lng": 128.591096064085
  },
  {
    "name": "반야월",
    "lat": 35.8659589028698,
    "lng": 128.713590817849
  },
  {
    "name": "반월당",
    "lat": 35.8644964860509,
    "lng": 128.593332929389
  },
  {
    "name": "방촌",
    "lat": 35.8796369539707,
    "lng": 128.670170788121
  },
  {
    "name": "상인",
    "lat": 35.8189194514905,
    "lng": 128.537763411316
  },
  {
    "name": "설화명곡",
    "lat": 35.7987123327622,
    "lng": 128.489344066951
  },
  {
    "name": "성당못",
    "lat": 35.8371792245284,
    "lng": 128.557173085249
  },
  {
    "name": "송현",
    "lat": 35.8310318233134,
    "lng": 128.551719090627
  },
  {
    "name": "신기",
    "lat": 37.345927256307,
    "lng": 129.084976674615
  },
  {
    "name": "신천",
    "lat": 35.8746760324725,
    "lng": 128.617851051566
  },
  {
    "name": "아양교",
    "lat": 35.8871908391627,
    "lng": 128.639920975458
  },
  {
    "name": "안심",
    "lat": 35.8712022704242,
    "lng": 128.733765080081
  },
  {
    "name": "안지랑",
    "lat": 35.8392164432878,
    "lng": 128.573725177851
  },
  {
    "name": "영대병원",
    "lat": 35.8441464017722,
    "lng": 128.58805585885
  },
  {
    "name": "용계",
    "lat": 35.8761014855902,
    "lng": 128.682010186069
  },
  {
    "name": "월배",
    "lat": 35.8161659635543,
    "lng": 128.530385897121
  },
  {
    "name": "월촌",
    "lat": 35.8236868611695,
    "lng": 128.545468163237
  },
  {
    "name": "율하",
    "lat": 35.8697875076123,
    "lng": 128.692704380891
  },
  {
    "name": "중앙로",
    "lat": 35.8708501133771,
    "lng": 128.593969444883
  },
  {
    "name": "진천",
    "lat": 35.8138799383459,
    "lng": 128.523062072253
  },
  {
    "name": "칠성시장",
    "lat": 35.8760903724485,
    "lng": 128.605124573102
  },
  {
    "name": "큰고개",
    "lat": 35.8840376292457,
    "lng": 128.631927449984
  },
  {
    "name": "해안",
    "lat": 35.8835322129174,
    "lng": 128.659600169354
  },
  {
    "name": "현충로",
    "lat": 35.8409351756246,
    "lng": 128.58146206116
  },
  {
    "name": "화원",
    "lat": 35.8044645552995,
    "lng": 128.500713083099
  },
  {
    "name": "감삼",
    "lat": 35.8543099591059,
    "lng": 128.548121282533
  },
  {
    "name": "강창",
    "lat": 35.8530780898695,
    "lng": 128.478516220553
  },
  {
    "name": "경대병원",
    "lat": 35.8631437353553,
    "lng": 128.602892882149
  },
  {
    "name": "계명대",
    "lat": 35.8515076071553,
    "lng": 128.491836327568
  },
  {
    "name": "고산",
    "lat": 35.8429262579099,
    "lng": 128.69324006006
  },
  {
    "name": "내당",
    "lat": 35.8601156155721,
    "lng": 128.564640118628
  },
  {
    "name": "다사",
    "lat": 35.8648229875689,
    "lng": 128.458386021034
  },
  {
    "name": "담티",
    "lat": 35.8547735101299,
    "lng": 128.653975024565
  },
  {
    "name": "대공원",
    "lat": 35.8426979436612,
    "lng": 128.679976366306
  },
  {
    "name": "대구은행",
    "lat": 35.8597493327492,
    "lng": 128.61411591373
  },
  {
    "name": "대실",
    "lat": 35.8576022557459,
    "lng": 128.46524992458
  },
  {
    "name": "두류",
    "lat": 35.8572040925188,
    "lng": 128.555682839754
  },
  {
    "name": "만촌",
    "lat": 35.8588473102879,
    "lng": 128.644738903795
  },
  {
    "name": "문양",
    "lat": 35.8641437112211,
    "lng": 128.436984667647
  },
  {
    "name": "반고개",
    "lat": 35.8622449548787,
    "lng": 128.57271908971
  },
  {
    "name": "반월당",
    "lat": 35.8644964860509,
    "lng": 128.593332929389
  },
  {
    "name": "범어",
    "lat": 35.8590196842493,
    "lng": 128.626787185036
  },
  {
    "name": "사월",
    "lat": 35.8370264224766,
    "lng": 128.71529223248
  },
  {
    "name": "성서산업단지",
    "lat": 35.8517150726794,
    "lng": 128.506982677305
  },
  {
    "name": "수성구청",
    "lat": 35.8587913482908,
    "lng": 128.635638371464
  },
  {
    "name": "신남",
    "lat": 35.8641908810197,
    "lng": 128.582366875268
  },
  {
    "name": "신매",
    "lat": 35.8407936941253,
    "lng": 128.705125156966
  },
  {
    "name": "연호",
    "lat": 35.8465805743104,
    "lng": 128.671668697446
  },
  {
    "name": "영남대",
    "lat": 35.8361975090997,
    "lng": 128.75274551423
  },
  {
    "name": "용산역 대구2호",
    "lat": 35.8490603085768,
    "lng": 128.528804093655
  },
  {
    "name": "이곡",
    "lat": 35.8505949173867,
    "lng": 128.515794441163
  },
  {
    "name": "임당",
    "lat": 35.8341178335045,
    "lng": 128.740836819462
  },
  {
    "name": "정평",
    "lat": 35.834041297532,
    "lng": 128.728662341081
  },
  {
    "name": "죽전",
    "lat": 35.8507169997604,
    "lng": 128.538797872376
  },
  {
    "name": "건들바위",
    "lat": 35.8553826428892,
    "lng": 128.599681452388
  },
  {
    "name": "공단",
    "lat": 35.8919793873996,
    "lng": 128.553594363812
  },
  {
    "name": "구암",
    "lat": 35.9257423398405,
    "lng": 128.550332606006
  },
  {
    "name": "남산",
    "lat": 35.8566969947598,
    "lng": 128.583457701217
  },
  {
    "name": "달성공원",
    "lat": 35.8756751656703,
    "lng": 128.582085953652
  },
  {
    "name": "대봉교",
    "lat": 35.8549871395244,
    "lng": 128.606359383914
  },
  {
    "name": "동천",
    "lat": 35.9376993767704,
    "lng": 128.556682810229
  },
  {
    "name": "만평",
    "lat": 35.88982823115,
    "lng": 128.561038533394
  },
  {
    "name": "매천",
    "lat": 35.9126748779821,
    "lng": 128.543408922216
  },
  {
    "name": "매천시장",
    "lat": 35.9043545074362,
    "lng": 128.545728405085
  },
  {
    "name": "명덕",
    "lat": 35.8578216212265,
    "lng": 128.591096064085
  },
  {
    "name": "범물",
    "lat": 35.8208284803161,
    "lng": 128.640103620106
  },
  {
    "name": "북구청",
    "lat": 35.8837400679307,
    "lng": 128.581426946264
  },
  {
    "name": "서문시장",
    "lat": 35.8696535982898,
    "lng": 128.582231931722
  },
  {
    "name": "수성구민운동장",
    "lat": 35.8524097935471,
    "lng": 128.625124606656
  },
  {
    "name": "수성못",
    "lat": 35.8313489070586,
    "lng": 128.623212105964
  },
  {
    "name": "수성시장",
    "lat": 35.8543168751428,
    "lng": 128.616020365363
  },
  {
    "name": "신남",
    "lat": 35.8641908810197,
    "lng": 128.582366875268
  },
  {
    "name": "어린이회관",
    "lat": 35.8451554793509,
    "lng": 128.624467438861
  },
  {
    "name": "용지",
    "lat": 35.8182533885697,
    "lng": 128.646534236622
  },
  {
    "name": "원대",
    "lat": 35.8878340734269,
    "lng": 128.574354591033
  },
  {
    "name": "지산",
    "lat": 35.8251389841223,
    "lng": 128.631937734932
  },
  {
    "name": "칠곡경대병원",
    "lat": 35.958383988948,
    "lng": 128.559881826034
  },
  {
    "name": "칠곡운암",
    "lat": 35.9314554587022,
    "lng": 128.554521634866
  },
  {
    "name": "태전",
    "lat": 35.9196341144146,
    "lng": 128.54742160057
  },
  {
    "name": "팔거",
    "lat": 35.9440399509465,
    "lng": 128.558336478382
  },
  {
    "name": "팔달",
    "lat": 35.8978353227707,
    "lng": 128.546731313191
  },
  {
    "name": "팔달시장",
    "lat": 35.8888381758141,
    "lng": 128.567862898977
  },
  {
    "name": "학정",
    "lat": 35.9515443059237,
    "lng": 128.559193181731
  },
  {
    "name": "황금",
    "lat": 35.8390714164184,
    "lng": 128.62390067429
  },
  {
    "name": "녹동",
    "lat": 35.1067870742082,
    "lng": 126.933991024336
  },
  {
    "name": "소태",
    "lat": 35.1233352783732,
    "lng": 126.932397880621
  },
  {
    "name": "학동증심사입구",
    "lat": 35.1327251951351,
    "lng": 126.928396288774
  },
  {
    "name": "남광주",
    "lat": 35.139283789899,
    "lng": 126.922969911318
  },
  {
    "name": "문화전당",
    "lat": 35.1465828245531,
    "lng": 126.919890335472
  },
  {
    "name": "금남로4가",
    "lat": 35.1507073806179,
    "lng": 126.914508799173
  },
  {
    "name": "금남로5가",
    "lat": 35.1541828469145,
    "lng": 126.909303040379
  },
  {
    "name": "양동시장",
    "lat": 35.1543207844391,
    "lng": 126.901269215342
  },
  {
    "name": "돌고개",
    "lat": 35.1516474261654,
    "lng": 126.89492912483
  },
  {
    "name": "농성",
    "lat": 35.1532776541874,
    "lng": 126.883710763274
  },
  {
    "name": "화정",
    "lat": 35.1519546363326,
    "lng": 126.876601078382
  },
  {
    "name": "쌍촌",
    "lat": 35.1515866889154,
    "lng": 126.869533997616
  },
  {
    "name": "운천",
    "lat": 37.8799680237518,
    "lng": 126.769754046936
  },
  {
    "name": "상무",
    "lat": 35.1466588627059,
    "lng": 126.848537766757
  },
  {
    "name": "김대중컨벤션센터",
    "lat": 35.1432428029189,
    "lng": 126.841564971083
  },
  {
    "name": "공항",
    "lat": 35.1440652693202,
    "lng": 126.811627470696
  },
  {
    "name": "송정공원",
    "lat": 35.1435408172655,
    "lng": 126.799360308266
  },
  {
    "name": "광주송정역",
    "lat": 35.1374884645062,
    "lng": 126.791518717435
  },
  {
    "name": "도산",
    "lat": 35.131767691548,
    "lng": 126.787978399504
  },
  {
    "name": "평동",
    "lat": 35.1247214855717,
    "lng": 126.769565436581
  },
  {
    "name": "판암",
    "lat": 36.3169538598042,
    "lng": 127.458409493686
  },
  {
    "name": "신흥",
    "lat": 36.3196398553685,
    "lng": 127.448781492469
  },
  {
    "name": "대동",
    "lat": 36.3295750164063,
    "lng": 127.442824287083
  },
  {
    "name": "대전",
    "lat": 36.3322924978184,
    "lng": 127.434107666899
  },
  {
    "name": "중앙로",
    "lat": 36.3286454994888,
    "lng": 127.425823604261
  },
  {
    "name": "중구청",
    "lat": 36.3247926451719,
    "lng": 127.419543819728
  },
  {
    "name": "서대전네거리",
    "lat": 36.3224198217408,
    "lng": 127.412559740784
  },
  {
    "name": "오룡",
    "lat": 36.3286821373548,
    "lng": 127.404908048175
  },
  {
    "name": "용문",
    "lat": 36.3377705340242,
    "lng": 127.39274723166
  },
  {
    "name": "탄방",
    "lat": 36.3455472568459,
    "lng": 127.384565210585
  },
  {
    "name": "시청",
    "lat": 36.3515060383179,
    "lng": 127.386733493775
  },
  {
    "name": "정부청사",
    "lat": 37.4264939139217,
    "lng": 126.989854488907
  },
  {
    "name": "갈마",
    "lat": 36.3575701907458,
    "lng": 127.372792202566
  },
  {
    "name": "월평",
    "lat": 36.358244328886,
    "lng": 127.364595288792
  },
  {
    "name": "갑천",
    "lat": 36.3547415501051,
    "lng": 127.354685760045
  },
  {
    "name": "유성온천",
    "lat": 36.3537167933274,
    "lng": 127.341423509912
  },
  {
    "name": "구암",
    "lat": 36.3566847335431,
    "lng": 127.330718571127
  },
  {
    "name": "현충원",
    "lat": 36.3590701838083,
    "lng": 127.321793090447
  },
  {
    "name": "월드컵경기장",
    "lat": 36.3668489025955,
    "lng": 127.31783602361
  },
  {
    "name": "노은",
    "lat": 36.3741303075454,
    "lng": 127.317865643351
  },
  {
    "name": "지족",
    "lat": 36.3840929443941,
    "lng": 127.319488803267
  },
  {
    "name": "반석",
    "lat": 36.3922527537117,
    "lng": 127.314506333877
  },
  {
    "name": "별내별가람",
    "lat": 37.667819,
    "lng": 127.116118
  },
  {
    "name": "오남",
    "lat": 37.705214,
    "lng": 127.191174
  },
  {
    "name": "진접",
    "lat": 37.719896,
    "lng": 127.203219
  },
  {
    "name": "서울지방병무청역",
    "lat": 37.505772,
    "lng": 37.495396
  },
  {
    "name": "보라매공원",
    "lat": 37.495396,
    "lng": 126.9182601
  },
  {
    "name": "보라매병원",
    "lat": 37.49297,
    "lng": 126.9238121
  },
  {
    "name": "당곡",
    "lat": 37.490253,
    "lng": 126.9275591
  },
  {
    "name": "서원",
    "lat": 37.478229,
    "lng": 126.9331461
  },
  {
    "name": "서울대벤처타운",
    "lat": 37.472059,
    "lng": 126.9338921
  },
  {
    "name": "관악산",
    "lat": 37.468935,
    "lng": 126.9451491
  }
]



export default stationList
